var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4000px",
    height: "4000px",
    viewBox: "0 0 4000 4000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.06 0.04 4000 0.04 4000 4000 0.06 4000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.529,47.053 L24.059,47.053 C10.882,47.053 0.529,36.701 0.529,23.526 C0.529,10.352 10.882,0 24.059,0 L400.529,0 C413.706,0 424.059,10.352 424.059,23.526 C424.059,36.701 413.706,47.053 400.529,47.053 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.765,47.053 L23.588,47.053 C10.412,47.053 0.059,36.701 0.059,23.526 C0.059,10.352 10.412,0 23.588,0 L164.765,0 C177.941,0 188.294,10.352 188.294,23.526 C188.294,36.701 177.941,47.053 164.765,47.053 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.471,47.263 L24.059,47.263 C10.882,47.263 0.529,36.912 0.529,23.737 C0.529,10.562 10.882,0.21 24.059,0.21 L353.471,0.21 C366.647,0.21 377,10.562 377,23.737 C377,36.912 366.647,47.263 353.471,47.263 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.529,48.263 C16.941,48.263 11.294,45.44 6.588,41.676 C5.647,40.735 4.706,39.794 3.765,37.912 C2.824,36.97 1.882,35.088 1.882,34.147 C1.882,33.206 0.941,31.324 0.941,29.442 C0.941,27.56 0.941,26.619 0.941,24.737 C0.941,22.855 0.941,21.914 0.941,20.032 C0.941,18.149 1.882,17.208 1.882,15.327 C1.882,13.444 2.824,12.503 3.765,11.562 C4.706,10.621 5.647,8.739 6.588,7.798 C12.235,2.152 19.765,0.27 28.235,1.21 C30.118,1.21 31.059,2.152 32.941,2.152 C34.823,2.152 35.765,3.093 36.706,4.034 C37.647,4.975 39.53,5.916 40.471,6.857 C45.177,11.562 47.059,17.208 47.059,23.796 C47.059,30.383 44.235,36.03 40.471,40.735 C39.53,41.676 37.647,42.617 36.706,43.558 C35.765,44.499 33.882,45.44 32.941,45.44 C32,45.44 30.118,46.381 28.235,46.381 C26.353,48.263 25.412,48.263 23.529,48.263 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.368 L24.059,47.368 C10.882,47.368 0.529,37.017 0.529,23.842 C0.529,10.667 10.882,0.316 24.059,0.316 L118.177,0.316 C131.353,0.316 141.706,10.667 141.706,23.842 C141.706,37.017 131.353,47.368 118.177,47.368 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683,47.368 L24.177,47.368 C11,47.368 0.647,37.017 0.647,23.842 C0.647,10.667 11,0.316 24.177,0.316 L683,0.316 C696.177,0.316 706.529,10.667 706.529,23.842 C706.529,37.017 696.177,47.368 683,47.368 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.474 L24.059,47.474 C10.882,47.474 0.529,37.122 0.529,23.947 C0.529,10.773 10.882,0.421 24.059,0.421 L118.177,0.421 C131.353,0.421 141.706,10.773 141.706,23.947 C141.706,37.122 131.353,47.474 118.177,47.474 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.412,47.474 L24.177,47.474 C11,47.474 0.647,37.122 0.647,23.947 C0.647,10.773 11,0.421 24.177,0.421 L212.412,0.421 C225.588,0.421 235.941,10.773 235.941,23.947 C235.941,37.122 225.588,47.474 212.412,47.474 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.579 L24.059,47.579 C10.882,47.579 0.529,37.227 0.529,24.053 C0.529,10.878 10.882,0.526 24.059,0.526 L118.177,0.526 C131.353,0.526 141.706,10.878 141.706,24.053 C141.706,37.227 131.353,47.579 118.177,47.579 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.706,47.579 L24.177,47.579 C11,47.579 0.647,37.227 0.647,24.053 C0.647,10.878 11,0.526 24.177,0.526 L447.706,0.526 C460.882,0.526 471.235,10.878 471.235,24.053 C471.235,37.227 460.882,47.579 447.706,47.579 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.684 L24.059,47.684 C10.882,47.684 0.529,37.333 0.529,24.158 C0.529,10.983 10.882,0.632 24.059,0.632 L118.177,0.632 C131.353,0.632 141.706,10.983 141.706,24.158 C141.706,37.333 131.353,47.684 118.177,47.684 Z",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.353,47.895 L24.059,47.895 C10.882,47.895 0.529,37.543 0.529,24.368 C0.529,11.194 10.882,0.842 24.059,0.842 L259.353,0.842 C272.53,0.842 282.882,11.194 282.882,24.368 C282.882,37.543 272.53,47.895 259.353,47.895 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495,47.895 L24.412,47.895 C11.235,47.895 0.882,37.543 0.882,24.368 C0.882,11.194 11.235,0.842 24.412,0.842 L495,0.842 C508.177,0.842 518.529,11.194 518.529,24.368 C518.529,37.543 508.177,47.895 495,47.895 Z",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.412,47.895 L24.118,47.895 C10.941,47.895 0.588,37.543 0.588,24.368 C0.588,11.194 10.941,0.842 24.118,0.842 L259.412,0.842 C272.588,0.842 282.941,11.194 282.941,24.368 C282.941,37.543 272.588,47.895 259.412,47.895 Z",
    id: "path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.529,45.895 C21.647,45.895 20.706,45.895 18.823,45.895 C16.941,45.895 16,44.954 14.118,44.954 C12.235,44.013 11.294,44.013 10.353,43.072 C9.412,42.131 7.529,41.189 6.588,40.249 C5.647,39.307 4.706,37.425 3.765,36.484 C2.823,35.543 1.882,33.661 1.882,32.72 C1.882,31.779 0.941,29.897 0.941,28.015 C0.941,26.133 0.941,25.192 0.941,23.31 C0.941,21.428 0.941,20.486 0.941,18.604 C0.941,16.722 1.882,15.781 1.882,13.899 C1.882,12.017 2.823,11.076 3.765,10.135 C4.706,9.194 5.647,7.312 6.588,6.371 C7.529,5.429 9.412,4.489 10.353,3.547 C11.294,2.606 13.177,1.665 14.118,1.665 C15.059,0.724 16.941,0.724 18.823,0.724 C21.647,-0.217 25.412,-0.217 28.235,0.724 C30.118,0.724 31.059,1.665 32.941,1.665 C34.824,1.665 35.765,2.606 36.706,3.547 C37.647,4.489 39.529,5.429 40.471,6.371 C41.412,7.312 42.353,9.194 43.294,10.135 C44.235,11.076 45.177,12.958 45.177,13.899 C46.118,14.84 46.118,16.722 46.118,18.604 C46.118,20.486 47.059,21.428 47.059,23.31 C47.059,25.192 47.059,26.133 46.118,28.015 C46.118,29.897 45.177,30.838 45.177,32.72 C44.235,33.661 44.235,35.543 43.294,36.484 C42.353,37.425 41.412,39.307 40.471,40.249 C39.529,41.189 38.588,42.131 36.706,43.072 C35.765,44.013 33.882,44.954 32.941,44.954 C32,44.954 30.118,45.895 28.235,45.895 C26.353,45.895 25.412,45.895 23.529,45.895 Z",
    id: "path-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,48 L24.059,48 C10.882,48 0.529,37.648 0.529,24.474 C0.529,11.299 10.882,0.947 24.059,0.947 L118.177,0.947 C131.353,0.947 141.706,11.299 141.706,24.474 C141.706,37.648 131.353,48 118.177,48 Z",
    id: "path-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.353,48 L24.177,48 C11,48 0.647,37.648 0.647,24.474 C0.647,11.299 11,0.947 24.177,0.947 L165.353,0.947 C178.53,0.947 188.882,11.299 188.882,24.474 C188.882,37.648 178.53,48 165.353,48 Z",
    id: "path-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.765,48 L24.471,48 C11.294,48 0.941,37.648 0.941,24.474 C0.941,11.299 11.294,0.947 24.471,0.947 L259.765,0.947 C272.941,0.947 283.294,11.299 283.294,24.474 C283.294,37.648 272.941,48 259.765,48 Z",
    id: "path-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.105 L24.059,47.105 C10.882,47.105 0.529,36.754 0.529,23.579 C0.529,10.404 10.882,0.053 24.059,0.053 L118.177,0.053 C131.353,0.053 141.706,10.404 141.706,23.579 C141.706,36.754 131.353,47.105 118.177,47.105 Z",
    id: "path-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.353,47.316 L24.059,47.316 C10.882,47.316 0.529,36.964 0.529,23.79 C0.529,10.615 10.882,0.263 24.059,0.263 L259.353,0.263 C272.53,0.263 282.882,10.615 282.882,23.79 C282.882,36.964 272.53,47.316 259.353,47.316 Z",
    id: "path-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495,47.316 L24.412,47.316 C11.235,47.316 0.882,36.964 0.882,23.79 C0.882,10.615 11.235,0.263 24.412,0.263 L495,0.263 C508.177,0.263 518.529,10.615 518.529,23.79 C518.529,36.964 508.177,47.316 495,47.316 Z",
    id: "path-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.059,47.316 C17.471,47.316 11.823,44.493 7.118,40.729 C2.412,36.023 0.529,30.377 0.529,23.79 C0.529,17.202 3.353,11.556 7.118,6.851 C15.588,-1.619 31.588,-1.619 40.059,6.851 C44.765,11.556 46.647,17.202 46.647,23.79 C46.647,30.377 43.823,36.023 40.059,40.729 C36.294,44.493 30.647,47.316 24.059,47.316 Z",
    id: "path-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.177,47.316 L24.118,47.316 C10.941,47.316 0.588,36.964 0.588,23.79 C0.588,10.615 10.941,0.263 24.118,0.263 L71.177,0.263 C84.353,0.263 94.706,10.615 94.706,23.79 C94.706,36.964 84.353,47.316 71.177,47.316 Z",
    id: "path-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.529,47.316 L24.294,47.316 C11.118,47.316 0.765,36.964 0.765,23.79 C0.765,10.615 11.118,0.263 24.294,0.263 L212.529,0.263 C225.706,0.263 236.059,10.615 236.059,23.79 C236.059,36.964 225.706,47.316 212.529,47.316 Z",
    id: "path-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.353,47.316 L23.588,47.316 C10.412,47.316 0.059,36.964 0.059,23.79 C0.059,10.615 10.412,0.263 23.588,0.263 L635.353,0.263 C648.529,0.263 658.883,10.615 658.883,23.79 C658.883,36.964 648.529,47.316 635.353,47.316 Z",
    id: "path-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.412,46.316 C22.529,46.316 21.588,46.316 19.706,46.316 C17.823,46.316 16.882,45.375 15,45.375 C13.118,44.434 12.177,44.434 11.235,43.493 C10.294,42.552 8.412,41.611 7.471,40.669 C2.765,35.964 0.883,30.318 0.883,23.73 C0.883,21.848 0.883,20.908 0.883,19.025 C0.883,17.143 1.823,16.202 1.823,14.32 C2.765,13.379 2.765,11.497 3.706,10.556 C4.647,9.615 5.588,7.733 6.529,6.792 C7.471,5.851 9.353,4.909 10.294,3.969 C11.235,3.027 13.118,2.086 14.059,2.086 C15,1.145 16.882,1.145 18.765,1.145 C21.588,0.204 25.353,0.204 28.177,1.145 C30.059,1.145 31,2.086 32.882,2.086 C33.823,3.027 35.706,3.027 36.647,3.969 C37.588,4.909 39.471,5.851 40.412,6.792 C41.353,7.733 42.294,9.615 43.235,10.556 C44.177,11.497 45.118,13.379 45.118,14.32 C46.059,15.261 46.059,17.143 46.059,19.025 C46.059,20.908 46.059,21.848 46.059,23.73 C46.059,30.318 43.235,35.964 39.471,40.669 C38.529,41.611 36.647,42.552 35.706,43.493 C34.765,44.434 32.882,45.375 31.941,45.375 C30.059,46.316 29.118,46.316 27.235,46.316 C27.235,46.316 26.294,46.316 24.412,46.316 Z",
    id: "path-53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.882,47.316 L23.529,47.316 C10.353,47.316 0,36.964 0,23.79 C0,10.615 10.353,0.263 23.529,0.263 L305.882,0.263 C319.059,0.263 329.412,10.615 329.412,23.79 C329.412,36.964 319.059,47.316 305.882,47.316 Z",
    id: "path-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,47.316 C17.412,47.316 11.765,44.493 7.059,40.729 C2.353,36.023 0.471,30.377 0.471,23.79 C0.471,17.202 3.294,11.556 7.059,6.851 C8,5.909 9.882,4.969 10.823,4.027 C11.765,3.086 13.647,2.145 14.588,2.145 C15.529,1.204 17.412,1.204 19.294,1.204 C22.118,0.263 25.882,0.263 28.706,1.204 C30.588,1.204 31.529,2.145 33.412,2.145 C34.353,3.086 36.235,3.086 37.177,4.027 C38.118,4.969 40,5.909 40.941,6.851 C45.647,11.556 47.529,17.202 47.529,23.79 C47.529,30.377 44.706,36.023 40.941,40.729 C36.235,44.493 30.588,47.316 24,47.316 Z",
    id: "path-57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.294,47.316 L24.059,47.316 C10.882,47.316 0.529,36.964 0.529,23.79 C0.529,10.615 10.882,0.263 24.059,0.263 L212.294,0.263 C225.471,0.263 235.823,10.615 235.823,23.79 C235.823,36.964 225.471,47.316 212.294,47.316 Z",
    id: "path-59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.706,47.316 L24.353,47.316 C11.177,47.316 0.823,36.964 0.823,23.79 C0.823,10.615 11.177,0.263 24.353,0.263 L306.706,0.263 C319.882,0.263 330.235,10.615 330.235,23.79 C330.235,36.964 319.882,47.316 306.706,47.316 Z",
    id: "path-61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.765,47.316 C16.177,47.316 10.529,44.493 5.823,40.729 C4.882,39.787 3.941,37.905 3,36.964 C2.059,36.023 1.118,34.141 1.118,33.2 C0.177,32.259 0.177,30.377 0.177,28.495 C0.177,26.613 0.177,25.672 0.177,23.79 C0.177,21.908 0.177,20.966 0.177,19.084 C0.177,17.202 1.118,16.261 1.118,14.379 C2.059,13.438 2.059,11.556 3,10.615 C3.941,9.674 4.882,7.792 5.823,6.851 C6.765,5.909 7.706,4.969 9.588,4.027 C10.529,3.086 12.412,2.145 13.353,2.145 C14.294,1.204 16.177,1.204 18.059,1.204 C25.588,-0.678 34.059,2.145 39.706,7.792 C40.647,8.733 41.588,9.674 42.529,11.556 C43.471,13.438 44.412,14.379 44.412,15.32 C45.353,16.261 45.353,18.143 45.353,20.025 C45.353,21.908 45.353,22.848 45.353,24.73 C45.353,26.613 45.353,27.554 45.353,29.436 C45.353,31.318 44.412,32.259 44.412,34.141 C43.471,35.082 43.471,36.964 42.529,37.905 C41.588,38.846 40.647,40.729 39.706,41.669 C35,44.493 29.353,47.316 22.765,47.316 Z",
    id: "path-63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.882,47.316 C16.294,47.316 10.647,44.493 5.941,40.729 C5,39.787 4.059,37.905 3.118,36.964 C2.177,36.023 1.235,34.141 1.235,33.2 C0.294,32.259 0.294,30.377 0.294,28.495 C0.294,26.613 0.294,25.672 0.294,23.79 C0.294,21.908 0.294,20.966 0.294,19.084 C0.294,17.202 1.235,16.261 1.235,14.379 C2.177,13.438 2.177,11.556 3.118,10.615 C4.059,9.674 5,7.792 5.941,6.851 C11.588,1.204 20.059,-0.678 27.588,0.263 C29.471,0.263 30.412,1.204 32.294,1.204 C33.235,2.145 35.118,2.145 36.059,3.086 C37,4.027 38.882,4.969 39.824,5.909 C40.765,6.851 41.706,7.792 42.647,9.674 C43.588,11.556 44.529,12.497 44.529,13.438 C45.471,14.379 45.471,16.261 45.471,18.143 C45.471,20.025 45.471,20.966 45.471,22.848 C45.471,24.73 45.471,25.672 45.471,27.554 C45.471,29.436 44.529,30.377 44.529,32.259 C43.588,33.2 43.588,35.082 42.647,36.023 C41.706,36.964 40.765,38.846 39.824,39.787 C38.882,40.729 37,41.669 36.059,42.611 C35.118,43.552 33.235,44.493 32.294,44.493 C30.412,45.434 29.471,45.434 27.588,45.434 C25.706,47.316 24.765,47.316 22.882,47.316 Z",
    id: "path-65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.421 L24.059,47.421 C10.882,47.421 0.529,37.07 0.529,23.895 C0.529,10.72 10.882,0.368 24.059,0.368 L118.177,0.368 C131.353,0.368 141.706,10.72 141.706,23.895 C141.706,37.07 131.353,47.421 118.177,47.421 Z",
    id: "path-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.529,47.421 L24.177,47.421 C11,47.421 0.647,37.07 0.647,23.895 C0.647,10.72 11,0.368 24.177,0.368 L306.529,0.368 C319.706,0.368 330.059,10.72 330.059,23.895 C330.059,37.07 319.706,47.421 306.529,47.421 Z",
    id: "path-69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.706,47.421 L23.647,47.421 C10.471,47.421 0.118,37.07 0.118,23.895 C0.118,10.72 10.471,0.368 23.647,0.368 L70.706,0.368 C83.882,0.368 94.235,10.72 94.235,23.895 C94.235,37.07 83.882,47.421 70.706,47.421 Z",
    id: "path-71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,47.421 L23.823,47.421 C10.647,47.421 0.294,37.07 0.294,23.895 C0.294,10.72 10.647,0.368 23.823,0.368 L165,0.368 C178.177,0.368 188.529,10.72 188.529,23.895 C188.529,37.07 178.177,47.421 165,47.421 Z",
    id: "path-73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.059,46.421 C21.177,46.421 20.235,46.421 18.353,46.421 C16.471,46.421 15.53,45.48 13.647,45.48 C11.765,44.539 10.823,44.539 9.882,43.598 C8.941,42.657 7.059,41.716 6.118,40.775 C5.177,39.834 4.235,37.952 3.294,37.01 C2.353,36.07 1.412,34.187 1.412,33.246 C1.412,32.305 0.471,30.423 0.471,28.541 C0.471,26.659 0.471,25.718 0.471,23.836 C0.471,21.954 0.471,21.013 0.471,19.131 C0.471,17.249 1.412,16.307 1.412,14.425 C2.353,13.484 2.353,11.602 3.294,10.661 C4.235,9.72 5.177,7.838 6.118,6.897 C11.765,1.25 19.294,-0.632 27.765,0.31 C29.647,0.31 30.588,1.25 32.471,1.25 C34.353,1.25 35.294,2.192 36.235,3.133 C37.177,4.074 39.059,5.015 40,5.956 C40.941,6.897 41.882,8.779 42.823,9.72 C43.765,10.661 44.706,12.543 44.706,13.484 C45.647,15.366 45.647,16.307 45.647,18.189 C45.647,20.072 46.588,21.013 46.588,22.895 C46.588,29.482 43.765,35.128 40,39.834 C39.059,40.775 37.177,41.716 36.235,42.657 C35.294,43.598 33.412,44.539 32.471,44.539 C31.53,44.539 29.647,45.48 27.765,45.48 C25.882,46.421 24.941,46.421 23.059,46.421 Z",
    id: "path-75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.647,47.421 L24.118,47.421 C10.941,47.421 0.588,37.07 0.588,23.895 C0.588,10.72 10.941,0.368 24.118,0.368 L447.647,0.368 C460.823,0.368 471.177,10.72 471.177,23.895 C471.177,37.07 460.823,47.421 447.647,47.421 Z",
    id: "path-77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.706,46.421 C21.823,46.421 20.882,46.421 19,46.421 C17.118,46.421 16.177,45.48 14.294,45.48 C12.412,44.539 11.471,44.539 10.529,43.598 C9.588,42.657 7.706,41.716 6.765,40.775 C2.059,36.07 0.177,30.423 0.177,23.836 C0.177,21.954 0.177,21.013 0.177,19.131 C0.177,17.249 1.118,16.307 1.118,14.425 C2.059,13.484 2.059,11.602 3,10.661 C3.941,9.72 4.882,7.838 5.823,6.897 C6.765,5.956 8.647,5.015 9.588,4.074 C10.529,3.133 12.412,2.192 13.353,2.192 C14.294,1.25 16.177,1.25 18.059,1.25 C25.588,-0.632 34.059,2.192 39.706,7.838 C40.647,8.779 41.588,10.661 42.529,11.602 C43.471,12.543 44.412,14.425 44.412,15.366 C45.353,17.249 45.353,18.189 45.353,20.072 C45.353,21.954 46.294,22.895 46.294,24.777 C46.294,26.659 46.294,27.6 45.353,29.482 C45.353,31.364 44.412,32.305 44.412,34.187 C43.471,35.128 43.471,37.01 42.529,37.952 C41.588,38.893 40.647,40.775 39.706,41.716 C38.765,42.657 36.882,43.598 35.941,44.539 C35,45.48 33.118,46.421 32.177,46.421 C31.235,46.421 29.353,47.362 27.471,47.362 C26.529,46.421 25.588,46.421 23.706,46.421 Z",
    id: "path-79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.118,47.421 L23.765,47.421 C10.588,47.421 0.235,37.07 0.235,23.895 C0.235,10.72 10.588,0.368 23.765,0.368 L306.118,0.368 C319.294,0.368 329.647,10.72 329.647,23.895 C329.647,37.07 319.294,47.421 306.118,47.421 Z",
    id: "path-81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.177,47.421 C16.588,47.421 10.941,44.598 6.235,40.834 C5.294,39.893 4.353,38.01 3.412,37.07 C2.471,36.128 1.529,34.246 1.529,33.305 C0.588,32.364 0.588,30.482 0.588,28.6 C0.588,26.718 0.588,25.777 0.588,23.895 C0.588,22.013 0.588,21.072 0.588,19.189 C0.588,17.307 1.529,16.366 1.529,14.484 C2.471,13.543 2.471,11.661 3.412,10.72 C4.353,9.779 5.294,7.897 6.235,6.956 C14.706,-1.514 30.706,-1.514 39.177,6.956 C40.118,7.897 41.059,9.779 42,10.72 C42.941,11.661 43.882,13.543 43.882,14.484 C44.823,16.366 44.823,17.307 44.823,19.189 C44.823,21.072 44.823,22.013 44.823,23.895 C44.823,25.777 44.823,26.718 44.823,28.6 C44.823,30.482 43.882,31.423 43.882,33.305 C42.941,34.246 42.941,36.128 42,37.07 C41.059,38.01 40.118,39.893 39.177,40.834 C38.235,41.775 36.353,42.716 35.412,43.657 C34.471,44.598 32.588,45.539 31.647,45.539 C29.765,46.48 28.824,46.48 26.941,46.48 C26,47.421 25.059,47.421 23.177,47.421 Z",
    id: "path-83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.412,47.421 L24.235,47.421 C11.059,47.421 0.706,37.07 0.706,23.895 C0.706,10.72 11.059,0.368 24.235,0.368 L165.412,0.368 C178.588,0.368 188.941,10.72 188.941,23.895 C188.941,37.07 178.588,47.421 165.412,47.421 Z",
    id: "path-85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.471,46.421 C21.588,46.421 20.647,46.421 18.765,46.421 C16.882,46.421 15.941,45.48 14.059,45.48 C12.177,44.539 11.235,44.539 10.294,43.598 C9.353,42.657 7.471,41.716 6.529,40.775 C5.588,39.834 4.647,38.893 3.706,37.01 C2.765,36.07 1.823,34.187 1.823,33.246 C0.883,32.305 0.883,30.423 0.883,28.541 C0.883,26.659 0.883,25.718 0.883,23.836 C0.883,21.954 0.883,21.013 0.883,19.131 C0.883,17.249 1.823,16.307 1.823,14.425 C2.765,13.484 2.765,11.602 3.706,10.661 C4.647,9.72 5.588,7.838 6.529,6.897 C7.471,5.956 9.353,5.015 10.294,4.074 C11.235,3.133 13.118,2.192 14.059,2.192 C15,1.25 16.882,1.25 18.765,1.25 C21.588,0.31 25.353,0.31 28.177,1.25 C30.059,1.25 31,2.192 32.882,2.192 C33.823,3.133 35.706,3.133 36.647,4.074 C37.588,5.015 39.471,5.956 40.412,6.897 C41.353,7.838 42.294,9.72 43.235,10.661 C44.177,11.602 45.118,13.484 45.118,14.425 C46.059,16.307 46.059,17.249 46.059,19.131 C46.059,21.013 46.059,21.954 46.059,23.836 C46.059,30.423 43.235,36.07 39.471,40.775 C38.529,41.716 36.647,42.657 35.706,43.598 C34.765,44.539 32.882,45.48 31.941,45.48 C30.059,46.421 29.118,46.421 27.235,46.421 C26.294,46.421 25.353,46.421 23.471,46.421 Z",
    id: "path-87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.632 L24.059,47.632 C10.882,47.632 0.529,37.28 0.529,24.105 C0.529,10.931 10.882,0.579 24.059,0.579 L118.177,0.579 C131.353,0.579 141.706,10.931 141.706,24.105 C141.706,37.28 131.353,47.632 118.177,47.632 Z",
    id: "path-89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.294,47.632 L24.177,47.632 C11,47.632 0.647,37.28 0.647,24.105 C0.647,10.931 11,0.579 24.177,0.579 L118.294,0.579 C131.471,0.579 141.824,10.931 141.824,24.105 C141.824,37.28 131.471,47.632 118.294,47.632 Z",
    id: "path-91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.412,47.632 C17.824,47.632 12.177,44.808 7.471,41.044 C2.765,36.339 0.882,30.693 0.882,24.105 C0.882,22.223 0.882,21.282 0.882,19.4 C0.882,17.518 1.824,16.577 1.824,14.695 C2.765,13.754 2.765,11.872 3.706,10.931 C4.647,9.99 5.588,8.108 6.529,7.166 C12.177,1.52 19.706,-0.362 28.177,0.579 C30.059,0.579 31,1.52 32.882,1.52 C34.765,1.52 35.706,2.461 36.647,3.402 C37.588,4.343 39.471,5.284 40.412,6.225 C41.353,7.166 42.294,9.048 43.235,9.99 C44.177,10.931 45.118,12.813 45.118,13.754 C46.059,15.636 46.059,16.577 46.059,18.459 C46.059,20.341 47,21.282 47,23.164 C47,29.752 44.177,35.398 40.412,40.103 C39.471,41.044 37.588,41.985 36.647,42.926 C35.706,43.867 33.823,44.808 32.882,44.808 C31,45.75 30.059,45.75 28.177,45.75 C27.235,47.632 26.294,47.632 24.412,47.632 Z",
    id: "path-93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.118,47.632 L23.529,47.632 C10.353,47.632 0,37.28 0,24.105 C0,10.931 10.353,0.579 23.529,0.579 L494.118,0.579 C507.294,0.579 517.647,10.931 517.647,24.105 C517.647,37.28 507.294,47.632 494.118,47.632 Z",
    id: "path-95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.737 L24.059,47.737 C10.882,47.737 0.529,37.385 0.529,24.211 C0.529,11.036 10.882,0.684 24.059,0.684 L118.177,0.684 C131.353,0.684 141.706,11.036 141.706,24.211 C141.706,37.385 131.353,47.737 118.177,47.737 Z",
    id: "path-97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.294,47.737 L24.177,47.737 C11,47.737 0.647,37.385 0.647,24.211 C0.647,11.036 11,0.684 24.177,0.684 L118.294,0.684 C131.471,0.684 141.824,11.036 141.824,24.211 C141.824,37.385 131.471,47.737 118.294,47.737 Z",
    id: "path-99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.471,47.737 L24.412,47.737 C11.235,47.737 0.882,37.385 0.882,24.211 C0.882,11.036 11.235,0.684 24.412,0.684 L71.471,0.684 C84.647,0.684 95,11.036 95,24.211 C95,37.385 84.647,47.737 71.471,47.737 Z",
    id: "path-101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.941,47.737 L23.588,47.737 C10.412,47.737 0.059,37.385 0.059,24.211 C0.059,11.036 10.412,0.684 23.588,0.684 L305.941,0.684 C319.118,0.684 329.471,11.036 329.471,24.211 C329.471,37.385 319.118,47.737 305.941,47.737 Z",
    id: "path-103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,46.737 C21.118,46.737 20.177,46.737 18.294,46.737 C16.412,46.737 15.471,45.796 13.588,45.796 C11.706,44.855 10.765,44.855 9.823,43.914 C8.882,42.973 7,42.032 6.059,41.091 C5.118,40.149 4.177,39.208 3.235,37.326 C2.294,36.385 1.353,34.503 1.353,33.562 C0.412,32.621 0.412,30.739 0.412,28.857 C0.412,26.975 0.412,26.034 0.412,24.152 C0.412,17.564 3.235,11.918 7,7.213 C7.941,6.272 9.823,5.331 10.765,4.39 C11.706,3.448 13.588,2.507 14.53,2.507 C15.471,1.566 17.353,1.566 19.235,1.566 C26.765,-0.316 35.235,2.507 40.882,8.154 C45.588,12.859 47.471,18.505 47.471,25.093 C47.471,26.975 47.471,27.916 46.529,29.798 C46.529,31.68 45.588,32.621 45.588,34.503 C44.647,36.385 44.647,37.326 43.706,38.267 C42.765,39.208 41.823,41.091 40.882,42.032 C35.235,43.914 29.588,46.737 23,46.737 Z",
    id: "path-105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.353,47.737 L24.059,47.737 C10.882,47.737 0.529,37.385 0.529,24.211 C0.529,11.036 10.882,0.684 24.059,0.684 L259.353,0.684 C272.529,0.684 282.882,11.036 282.882,24.211 C282.882,37.385 272.529,47.737 259.353,47.737 Z",
    id: "path-107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.412,46.737 C17.823,46.737 12.177,43.914 7.471,40.149 C2.765,35.444 0.882,29.798 0.882,23.211 C0.882,16.623 3.706,10.977 7.471,6.272 C8.412,5.331 9.353,4.39 11.235,3.448 C12.177,2.507 14.059,1.566 15,1.566 C15.941,0.625 17.823,0.625 19.706,0.625 C27.235,-1.257 35.706,1.566 41.353,7.213 C46.059,11.918 47.941,17.564 47.941,24.152 C47.941,26.034 47.941,26.975 47,28.857 C47,30.739 46.059,31.68 46.059,33.562 C45.118,35.444 45.118,36.385 44.177,37.326 C43.235,38.267 42.294,40.149 41.353,41.091 C36.647,43.914 31,46.737 24.412,46.737 Z",
    id: "path-109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.471,47.737 C16.882,47.737 11.235,44.914 6.529,41.149 C5.588,40.208 4.647,39.267 3.706,37.385 C2.765,36.444 1.823,34.562 1.823,33.621 C0.882,32.68 0.882,30.798 0.882,28.916 C0.882,27.034 0.882,26.093 0.882,24.211 C0.882,17.623 3.706,11.977 7.471,7.272 C8.412,6.331 10.294,5.39 11.235,4.448 C12.177,3.507 14.059,2.566 15,2.566 C15.941,1.625 17.823,1.625 19.706,1.625 C22.529,0.684 26.294,0.684 29.118,1.625 C31,1.625 31.941,2.566 33.824,2.566 C35.706,2.566 36.647,3.507 37.588,4.448 C38.53,5.39 40.412,6.331 41.353,7.272 C46.059,11.977 47.941,17.623 47.941,24.211 C47.941,26.093 47.941,27.034 47,28.916 C47,30.798 46.059,31.739 46.059,33.621 C45.118,35.503 45.118,36.444 44.177,37.385 C43.235,38.326 42.294,40.208 41.353,41.149 C35.706,44.914 30.059,47.737 23.471,47.737 Z",
    id: "path-111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.529,46.737 C21.647,46.737 20.706,46.737 18.823,46.737 C16.941,46.737 16,45.796 14.118,45.796 C12.235,44.855 11.294,44.855 10.353,43.914 C9.412,42.973 7.529,42.032 6.588,41.091 C5.647,40.149 4.706,39.208 3.765,37.326 C2.823,36.385 1.882,34.503 1.882,33.562 C0.941,32.621 0.941,30.739 0.941,28.857 C0.941,26.975 0.941,26.034 0.941,24.152 C0.941,17.564 3.765,11.918 7.529,7.213 C16,-1.257 32,-1.257 40.471,7.213 C41.412,8.154 42.353,10.036 43.294,10.977 C44.235,11.918 45.177,13.8 45.177,14.741 C46.118,16.623 46.118,17.564 46.118,19.446 C46.118,21.328 47.059,22.27 47.059,24.152 C47.059,30.739 44.235,36.385 40.471,41.091 C39.529,42.032 37.647,42.973 36.706,43.914 C35.765,44.855 33.882,45.796 32.941,45.796 C32,46.737 30.118,46.737 28.235,46.737 C26.353,46.737 25.412,46.737 23.529,46.737 Z",
    id: "path-113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.588,46.737 C21.706,46.737 20.765,46.737 18.882,46.737 C17,46.737 16.059,45.796 14.177,45.796 C12.294,44.855 11.353,44.855 10.412,43.914 C9.471,42.973 7.588,42.032 6.647,41.091 C1.941,36.385 0.059,30.739 0.059,24.152 C0.059,17.564 2.882,11.918 6.647,7.213 C7.588,6.272 9.471,5.331 10.412,4.39 C11.353,3.448 13.235,2.507 14.177,2.507 C15.118,1.566 17,1.566 18.882,1.566 C21.706,0.625 25.471,0.625 28.294,1.566 C30.177,1.566 31.118,2.507 33,2.507 C34.882,2.507 35.823,3.448 36.765,4.39 C37.706,5.331 39.588,6.272 40.529,7.213 C45.235,11.918 47.118,17.564 47.118,24.152 C47.118,26.034 47.118,26.975 46.177,28.857 C46.177,30.739 45.235,31.68 45.235,33.562 C44.294,35.444 44.294,36.385 43.353,37.326 C42.412,38.267 41.471,40.149 40.529,41.091 C35.823,43.914 30.177,46.737 23.588,46.737 Z",
    id: "path-115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.947 L24.059,47.947 C10.882,47.947 0.529,37.596 0.529,24.421 C0.529,11.246 10.882,0.895 24.059,0.895 L118.177,0.895 C131.353,0.895 141.706,11.246 141.706,24.421 C141.706,37.596 131.353,47.947 118.177,47.947 Z",
    id: "path-117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.235,47.947 L24.177,47.947 C11,47.947 0.647,37.596 0.647,24.421 C0.647,11.246 11,0.895 24.177,0.895 L71.235,0.895 C84.412,0.895 94.765,11.246 94.765,24.421 C94.765,37.596 84.412,47.947 71.235,47.947 Z",
    id: "path-119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.471,47.947 L24.353,47.947 C11.177,47.947 0.824,37.596 0.824,24.421 C0.824,11.246 11.177,0.895 24.353,0.895 L118.471,0.895 C131.647,0.895 142,11.246 142,24.421 C142,37.596 131.647,47.947 118.471,47.947 Z",
    id: "path-121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.647,47.947 L23.588,47.947 C10.412,47.947 0.059,37.596 0.059,24.421 C0.059,11.246 10.412,0.895 23.588,0.895 L70.647,0.895 C83.823,0.895 94.177,11.246 94.177,24.421 C94.177,37.596 83.823,47.947 70.647,47.947 Z",
    id: "path-123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.882,47.947 L23.765,47.947 C10.588,47.947 0.235,37.596 0.235,24.421 C0.235,11.246 10.588,0.895 23.765,0.895 L117.882,0.895 C131.059,0.895 141.412,11.246 141.412,24.421 C141.412,37.596 131.059,47.947 117.882,47.947 Z",
    id: "path-125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,46.947 C16.412,46.947 10.765,44.124 6.059,40.36 C5.118,39.419 4.177,38.478 3.235,36.596 C2.294,35.655 1.353,33.773 1.353,32.832 C0.412,31.891 0.412,30.008 0.412,28.126 C0.412,26.244 0.412,25.303 0.412,23.421 C0.412,21.539 0.412,20.598 0.412,18.716 C0.412,16.834 1.353,15.893 1.353,14.01 C2.294,13.07 2.294,11.187 3.235,10.246 C4.177,9.305 5.118,7.423 6.059,6.482 C7,5.541 7.941,4.6 9.823,3.659 C10.765,2.718 12.647,1.777 13.588,1.777 C14.53,0.836 16.412,0.836 18.294,0.836 C21.118,-0.105 24.882,-0.105 27.706,0.836 C29.588,0.836 30.53,1.777 32.412,1.777 C34.294,1.777 35.235,2.718 36.177,3.659 C37.118,4.6 39,5.541 39.941,6.482 C40.882,7.423 41.823,9.305 42.765,10.246 C43.706,11.187 44.647,13.07 44.647,14.01 C45.588,15.893 45.588,16.834 45.588,18.716 C45.588,20.598 46.529,21.539 46.529,23.421 C46.529,25.303 46.529,26.244 45.588,28.126 C45.588,30.008 44.647,30.95 44.647,32.832 C43.706,34.714 43.706,35.655 42.765,36.596 C41.823,37.537 40.882,39.419 39.941,40.36 C39,41.301 37.118,42.242 36.177,43.183 C35.235,44.124 33.353,45.065 32.412,45.065 C30.53,46.006 29.588,46.006 27.706,46.006 C25.823,46.947 24.882,46.947 23,46.947 Z",
    id: "path-127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.235,47.053 L24.059,47.053 C10.882,47.053 0.529,36.701 0.529,23.526 C0.529,10.352 10.882,0 24.059,0 L165.235,0 C178.412,0 188.765,10.352 188.765,23.526 C188.765,36.701 178.412,47.053 165.235,47.053 Z",
    id: "path-129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.471,47.053 L24.235,47.053 C11.059,47.053 0.706,36.701 0.706,23.526 C0.706,10.352 11.059,0 24.235,0 L212.471,0 C225.647,0 236,10.352 236,23.526 C236,36.701 225.647,47.053 212.471,47.053 Z",
    id: "path-131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.529,47.053 C16.941,47.053 11.294,44.229 6.588,40.465 C1.882,35.76 0,30.114 0,23.526 C0,21.644 0,20.703 0,18.821 C0,16.939 0.941,15.998 0.941,14.116 C1.882,13.175 1.882,11.293 2.824,10.352 C3.765,9.411 4.706,7.529 5.647,6.587 C6.588,5.646 8.471,4.705 9.412,3.764 C10.353,2.823 12.235,1.882 13.177,1.882 C15.059,0.941 16,0.941 17.882,0.941 C25.412,-0.941 33.882,1.882 39.53,7.529 C40.471,8.469 41.412,9.411 42.353,11.293 C43.294,12.234 44.235,14.116 44.235,15.057 C45.177,16.939 45.177,17.88 45.177,19.762 C45.177,21.644 46.118,22.585 46.118,24.467 C46.118,31.055 43.294,36.701 39.53,41.406 C35.765,44.229 30.118,47.053 23.529,47.053 Z",
    id: "path-133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.706,47.053 L23.588,47.053 C10.412,47.053 0.059,36.701 0.059,23.526 C0.059,10.352 10.412,0 23.588,0 L117.706,0 C130.882,0 141.235,10.352 141.235,23.526 C141.235,36.701 130.882,47.053 117.706,47.053 Z",
    id: "path-135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.765,47.053 C17.177,47.053 11.53,44.229 6.823,40.465 C2.118,35.76 0.235,30.114 0.235,23.526 C0.235,16.939 3.059,11.293 6.823,6.587 C7.765,5.646 8.706,4.705 10.588,3.764 C11.53,2.823 13.412,1.882 14.353,1.882 C15.294,0.941 17.177,0.941 19.059,0.941 C21.882,0 25.647,0 28.471,0.941 C30.353,0.941 31.294,1.882 33.177,1.882 C35.059,1.882 36,2.823 36.941,3.764 C37.882,4.705 39.765,5.646 40.706,6.587 C41.647,7.529 42.588,8.469 43.529,10.352 C44.471,11.293 45.412,13.175 45.412,14.116 C46.353,15.998 46.353,16.939 46.353,18.821 C46.353,20.703 47.294,21.644 47.294,23.526 C47.294,30.114 44.471,35.76 40.706,40.465 C39.765,41.406 37.882,42.347 36.941,43.289 C36,44.229 34.118,45.171 33.177,45.171 C32.235,46.112 30.353,46.112 28.471,46.112 C26.588,47.053 25.647,47.053 23.765,47.053 Z",
    id: "path-137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.235,47.158 L24.059,47.158 C10.882,47.158 0.529,36.806 0.529,23.632 C0.529,10.457 10.882,0.105 24.059,0.105 L165.235,0.105 C178.412,0.105 188.765,10.457 188.765,23.632 C188.765,36.806 178.412,47.158 165.235,47.158 Z",
    id: "path-139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.368 L24.059,47.368 C10.882,47.368 0.529,37.017 0.529,23.842 C0.529,10.667 10.882,0.316 24.059,0.316 L118.177,0.316 C131.353,0.316 141.706,10.667 141.706,23.842 C141.706,37.017 131.353,47.368 118.177,47.368 Z",
    id: "path-141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.294,47.368 L24.177,47.368 C11,47.368 0.647,37.017 0.647,23.842 C0.647,10.667 11,0.316 24.177,0.316 L118.294,0.316 C131.471,0.316 141.824,10.667 141.824,23.842 C141.824,37.017 131.471,47.368 118.294,47.368 Z",
    id: "path-143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.353,47.368 C17.765,47.368 12.118,44.545 7.412,40.781 C2.706,36.076 0.824,30.429 0.824,23.842 C0.824,21.96 0.824,21.019 0.824,19.137 C0.824,17.255 1.765,16.314 1.765,14.432 C2.706,13.49 2.706,11.608 3.647,10.667 C4.588,9.726 5.529,7.844 6.471,6.903 C7.412,5.962 9.294,5.021 10.235,4.08 C11.177,3.139 13.059,2.198 14,2.198 C14.941,1.257 16.824,1.257 18.706,1.257 C21.529,0.316 25.294,0.316 28.118,1.257 C30,1.257 30.941,2.198 32.823,2.198 C34.706,2.198 35.647,3.139 36.588,4.08 C37.53,5.021 39.412,5.962 40.353,6.903 C41.294,7.844 42.235,9.726 43.177,10.667 C44.118,11.608 45.059,13.49 45.059,14.432 C46,16.314 46,17.255 46,19.137 C46,21.019 46.941,21.96 46.941,23.842 C46.941,30.429 44.118,36.076 40.353,40.781 C36.588,44.545 30.941,47.368 24.353,47.368 Z",
    id: "path-145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.765,47.368 L24.412,47.368 C11.235,47.368 0.882,37.017 0.882,23.842 C0.882,10.667 11.235,0.316 24.412,0.316 L306.765,0.316 C319.941,0.316 330.294,10.667 330.294,23.842 C330.294,37.017 319.941,47.368 306.765,47.368 Z",
    id: "path-147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.823,47.368 C17.235,47.368 11.588,44.545 6.882,40.781 C2.177,36.076 0.294,30.429 0.294,23.842 C0.294,21.96 0.294,21.019 0.294,19.137 C0.294,17.255 1.235,16.314 1.235,14.432 C2.177,13.49 2.177,11.608 3.118,10.667 C4.059,9.726 5,7.844 5.941,6.903 C6.882,5.962 8.765,5.021 9.706,4.08 C10.647,3.139 12.53,2.198 13.471,2.198 C14.412,1.257 16.294,1.257 18.177,1.257 C21,0.316 24.765,0.316 27.588,1.257 C29.471,1.257 30.412,2.198 32.294,2.198 C34.177,2.198 35.118,3.139 36.059,4.08 C37,5.021 38.882,5.962 39.823,6.903 C40.765,7.844 41.706,9.726 42.647,10.667 C43.588,11.608 44.529,13.49 44.529,14.432 C45.471,16.314 45.471,17.255 45.471,19.137 C45.471,21.019 46.412,21.96 46.412,23.842 C46.412,30.429 43.588,36.076 39.823,40.781 C36.059,44.545 30.412,47.368 23.823,47.368 Z",
    id: "path-149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.882,47.368 C17.294,47.368 11.647,44.545 6.941,40.781 C2.235,36.076 0.353,30.429 0.353,23.842 C0.353,21.96 0.353,21.019 0.353,19.137 C0.353,17.255 1.294,16.314 1.294,14.432 C2.235,13.49 2.235,11.608 3.177,10.667 C4.118,9.726 5.059,7.844 6,6.903 C6.941,5.962 8.823,5.021 9.765,4.08 C10.706,3.139 12.588,2.198 13.53,2.198 C14.471,1.257 16.353,1.257 18.235,1.257 C21.059,0.316 24.823,0.316 27.647,1.257 C29.529,1.257 30.471,2.198 32.353,2.198 C34.235,2.198 35.177,3.139 36.118,4.08 C37.059,5.021 38.941,5.962 39.882,6.903 C40.823,7.844 41.765,9.726 42.706,10.667 C43.647,11.608 44.588,13.49 44.588,14.432 C45.529,16.314 45.529,17.255 45.529,19.137 C45.529,21.019 46.471,21.96 46.471,23.842 C46.471,30.429 43.647,36.076 39.882,40.781 C36.118,44.545 30.471,47.368 23.882,47.368 Z",
    id: "path-151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.941,47.368 C17.353,47.368 11.706,44.545 7,40.781 C2.294,36.076 0.412,30.429 0.412,23.842 C0.412,21.96 0.412,21.019 0.412,19.137 C0.412,17.255 1.353,16.314 1.353,14.432 C2.294,13.49 2.294,11.608 3.235,10.667 C4.177,9.726 5.118,7.844 6.059,6.903 C7,5.962 8.882,5.021 9.823,4.08 C10.765,3.139 12.647,2.198 13.588,2.198 C14.53,1.257 16.412,1.257 18.294,1.257 C21.118,0.316 24.882,0.316 27.706,1.257 C29.588,1.257 30.529,2.198 32.412,2.198 C34.294,2.198 35.235,3.139 36.177,4.08 C37.118,5.021 39,5.962 39.941,6.903 C40.882,7.844 41.823,9.726 42.765,10.667 C43.706,11.608 44.647,13.49 44.647,14.432 C45.588,16.314 45.588,17.255 45.588,19.137 C45.588,21.019 46.529,21.96 46.529,23.842 C46.529,30.429 43.706,36.076 39.941,40.781 C36.177,44.545 30.529,47.368 23.941,47.368 Z",
    id: "path-153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.177,47.368 L24,47.368 C10.823,47.368 0.471,37.017 0.471,23.842 C0.471,10.667 10.823,0.316 24,0.316 L165.177,0.316 C178.353,0.316 188.706,10.667 188.706,23.842 C188.706,37.017 178.353,47.368 165.177,47.368 Z",
    id: "path-155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.235,47.368 C17.647,47.368 12,44.545 7.294,40.781 C2.588,36.076 0.706,30.429 0.706,23.842 C0.706,21.96 0.706,21.019 0.706,19.137 C0.706,17.255 1.647,16.314 1.647,14.432 C2.588,13.49 2.588,11.608 3.529,10.667 C4.471,9.726 5.412,7.844 6.353,6.903 C7.294,5.962 9.177,5.021 10.118,4.08 C11.059,3.139 12.941,2.198 13.882,2.198 C14.823,1.257 16.706,1.257 18.588,1.257 C21.412,0.316 25.177,0.316 28,1.257 C29.882,1.257 30.823,2.198 32.706,2.198 C33.647,3.139 35.529,3.139 36.471,4.08 C37.412,5.021 39.294,5.962 40.235,6.903 C41.177,7.844 42.118,9.726 43.059,10.667 C44,11.608 44.941,13.49 44.941,14.432 C45.882,16.314 45.882,17.255 45.882,19.137 C45.882,21.019 46.823,21.96 46.823,23.842 C46.823,30.429 44,36.076 40.235,40.781 C36.471,44.545 30.823,47.368 24.235,47.368 Z",
    id: "path-157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.474 L24.059,47.474 C10.882,47.474 0.529,37.122 0.529,23.947 C0.529,10.773 10.882,0.421 24.059,0.421 L118.177,0.421 C131.353,0.421 141.706,10.773 141.706,23.947 C141.706,37.122 131.353,47.474 118.177,47.474 Z",
    id: "path-159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.353,47.684 L24.059,47.684 C10.882,47.684 0.529,37.333 0.529,24.158 C0.529,10.983 10.882,0.632 24.059,0.632 L259.353,0.632 C272.53,0.632 282.882,10.983 282.882,24.158 C282.882,37.333 272.53,47.684 259.353,47.684 Z",
    id: "path-161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.588,47.684 L24.412,47.684 C11.235,47.684 0.882,37.333 0.882,24.158 C0.882,10.983 11.235,0.632 24.412,0.632 L165.588,0.632 C178.765,0.632 189.118,10.983 189.118,24.158 C189.118,37.333 178.765,47.684 165.588,47.684 Z",
    id: "path-163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.706,47.684 L23.647,47.684 C10.471,47.684 0.118,37.333 0.118,24.158 C0.118,10.983 10.471,0.632 23.647,0.632 L70.706,0.632 C83.882,0.632 94.235,10.983 94.235,24.158 C94.235,37.333 83.882,47.684 70.706,47.684 Z",
    id: "path-165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.823,46.684 C20.941,46.684 20,46.684 18.118,46.684 C16.235,46.684 15.294,45.743 13.412,45.743 C11.53,44.802 10.588,44.802 9.647,43.861 C8.706,42.92 6.823,41.979 5.882,41.038 C4.941,40.097 4,39.156 3.059,37.274 C2.118,36.333 1.177,34.45 1.177,33.509 C0.235,32.568 0.235,30.686 0.235,28.804 C0.235,26.922 0.235,25.981 0.235,24.099 C0.235,17.512 3.059,11.865 6.823,7.16 C12.471,1.514 20,-0.368 28.471,0.573 C30.353,0.573 31.294,1.514 33.177,1.514 C35.059,1.514 36,2.455 36.941,3.396 C37.882,4.337 39.765,5.278 40.706,6.219 C45.412,10.924 47.294,16.571 47.294,23.158 C47.294,25.04 47.294,25.981 46.353,27.863 C46.353,29.745 45.412,30.686 45.412,32.568 C44.471,34.45 44.471,35.392 43.529,36.333 C42.588,37.274 41.647,39.156 40.706,40.097 C35.059,43.861 29.412,46.684 22.823,46.684 Z",
    id: "path-167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.789 L24.059,47.789 C10.882,47.789 0.529,37.438 0.529,24.263 C0.529,11.089 10.882,0.737 24.059,0.737 L118.177,0.737 C131.353,0.737 141.706,11.089 141.706,24.263 C141.706,37.438 131.353,47.789 118.177,47.789 Z",
    id: "path-169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.353,47.789 L24.177,47.789 C11,47.789 0.647,37.438 0.647,24.263 C0.647,11.089 11,0.737 24.177,0.737 L165.353,0.737 C178.53,0.737 188.882,11.089 188.882,24.263 C188.882,37.438 178.53,47.789 165.353,47.789 Z",
    id: "path-171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.412,47.789 C16.824,47.789 11.177,44.966 6.471,41.202 C5.529,40.261 4.588,39.32 3.647,37.438 C2.706,36.497 1.765,34.615 1.765,33.674 C0.824,32.733 0.824,30.851 0.824,28.968 C0.824,27.086 0.824,26.145 0.824,24.263 C0.824,22.381 0.824,21.44 0.824,19.558 C0.824,17.676 1.765,16.735 1.765,14.853 C2.706,13.912 2.706,12.029 3.647,11.089 C4.588,10.147 5.529,8.265 6.471,7.324 C7.412,6.383 9.294,5.442 10.235,4.501 C11.177,3.56 13.059,2.619 14,2.619 C14.941,1.678 16.824,1.678 18.706,1.678 C21.529,0.737 25.294,0.737 28.118,1.678 C30,1.678 30.941,2.619 32.823,2.619 C34.706,2.619 35.647,3.56 36.588,4.501 C37.53,5.442 39.412,6.383 40.353,7.324 C41.294,8.265 42.235,10.147 43.177,11.089 C44.118,12.029 45.059,13.912 45.059,14.853 C46,16.735 46,17.676 46,19.558 C46,21.44 46.941,22.381 46.941,24.263 C46.941,26.145 46.941,27.086 46,28.968 C46,30.851 45.059,31.792 45.059,33.674 C44.118,35.556 44.118,36.497 43.177,37.438 C42.235,38.379 41.294,40.261 40.353,41.202 C35.647,44.966 30,47.789 23.412,47.789 Z",
    id: "path-173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,47.789 L24.471,47.789 C11.294,47.789 0.941,37.438 0.941,24.263 C0.941,11.089 11.294,0.737 24.471,0.737 L448,0.737 C461.177,0.737 471.529,11.089 471.529,24.263 C471.529,37.438 461.177,47.789 448,47.789 Z",
    id: "path-175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.059,45.789 C21.177,45.789 20.235,45.789 18.353,45.789 C16.471,45.789 15.53,44.848 13.647,44.848 C11.765,43.907 10.823,43.907 9.882,42.966 C8.941,42.025 7.059,41.084 6.118,40.143 C5.177,39.202 4.235,38.261 3.294,36.379 C2.353,35.438 1.412,33.556 1.412,32.615 C0.471,31.674 0.471,29.792 0.471,27.909 C0.471,26.027 0.471,25.086 0.471,23.204 C0.471,21.322 0.471,20.381 0.471,18.499 C0.471,16.617 1.412,15.676 1.412,13.794 C2.353,12.853 2.353,10.97 3.294,10.029 C4.235,9.089 5.177,7.206 6.118,6.265 C7.059,5.324 8.941,4.383 9.882,3.442 C10.823,2.501 12.706,1.56 13.647,1.56 C14.588,0.619 16.471,0.619 18.353,0.619 C25.882,-1.263 34.353,1.56 40,7.206 C40.941,8.147 41.882,10.029 42.823,10.97 C43.765,11.912 44.706,13.794 44.706,14.735 C45.647,16.617 45.647,17.558 45.647,19.44 C45.647,21.322 46.588,22.263 46.588,24.145 C46.588,26.027 46.588,26.968 45.647,28.851 C45.647,30.733 44.706,31.674 44.706,33.556 C43.765,35.438 43.765,36.379 42.823,37.32 C41.882,38.261 40.941,40.143 40,41.084 C39.059,42.025 38.118,42.966 36.235,43.907 C35.294,44.848 33.412,45.789 32.471,45.789 C31.53,46.731 29.647,46.731 27.765,46.731 C25.882,45.789 24.941,45.789 23.059,45.789 Z",
    id: "path-177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.235,47.789 L24.118,47.789 C10.941,47.789 0.588,37.438 0.588,24.263 C0.588,11.089 10.941,0.737 24.118,0.737 L118.235,0.737 C131.412,0.737 141.765,11.089 141.765,24.263 C141.765,37.438 131.412,47.789 118.235,47.789 Z",
    id: "path-179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.294,47.789 C16.706,47.789 11.059,44.966 6.353,41.202 C5.412,40.261 4.471,39.32 3.529,37.438 C2.588,36.497 1.647,34.615 1.647,33.674 C0.706,32.733 0.706,30.851 0.706,28.968 C0.706,27.086 0.706,26.145 0.706,24.263 C0.706,22.381 0.706,21.44 0.706,19.558 C0.706,17.676 1.647,16.735 1.647,14.853 C2.588,13.912 2.588,12.029 3.529,11.089 C4.471,10.147 5.412,8.265 6.353,7.324 C12,1.678 19.53,-0.204 28,0.737 C29.882,0.737 30.823,1.678 32.706,1.678 C34.588,1.678 35.529,2.619 36.471,3.56 C37.412,4.501 39.294,5.442 40.235,6.383 C41.177,7.324 42.118,9.206 43.059,10.147 C44,11.089 44.941,12.97 44.941,13.912 C45.882,15.794 45.882,16.735 45.882,18.617 C45.882,20.499 46.823,21.44 46.823,23.322 C46.823,25.204 46.823,26.145 45.882,28.027 C45.882,29.909 44.941,30.851 44.941,32.733 C44,34.615 44,35.556 43.059,36.497 C42.118,37.438 41.177,39.32 40.235,40.261 C35.529,44.966 29.882,47.789 23.294,47.789 Z",
    id: "path-181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495,47.789 L24.412,47.789 C11.235,47.789 0.882,37.438 0.882,24.263 C0.882,11.089 11.235,0.737 24.412,0.737 L495,0.737 C508.177,0.737 518.529,11.089 518.529,24.263 C518.529,37.438 508.177,47.789 495,47.789 Z",
    id: "path-183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.059,46.789 C21.177,46.789 20.235,46.789 18.353,46.789 C16.471,46.789 15.529,45.848 13.647,45.848 C11.765,44.907 10.823,44.907 9.882,43.966 C8.941,43.025 7.059,42.084 6.118,41.143 C5.177,40.202 4.235,39.261 3.294,37.379 C2.353,36.438 1.412,34.556 1.412,33.615 C0.471,32.674 0.471,30.792 0.471,28.909 C0.471,27.027 0.471,26.086 0.471,24.204 C0.471,22.322 0.471,21.381 0.471,19.499 C0.471,17.617 1.412,16.676 1.412,14.794 C2.353,13.853 2.353,11.97 3.294,11.029 C4.235,10.089 5.177,8.206 6.118,7.265 C7.059,6.324 8,5.383 9.882,4.442 C10.823,3.501 12.706,2.56 13.647,2.56 C14.588,1.619 16.471,1.619 18.353,1.619 C21.177,0.678 24.941,0.678 27.765,1.619 C29.647,1.619 30.588,2.56 32.471,2.56 C33.412,3.501 35.294,3.501 36.235,4.442 C37.177,5.383 39.059,6.324 40,7.265 C40.941,8.206 41.882,10.089 42.823,11.029 C43.765,11.97 44.706,13.853 44.706,14.794 C45.647,16.676 45.647,17.617 45.647,19.499 C45.647,21.381 45.647,22.322 45.647,24.204 C45.647,26.086 45.647,27.027 45.647,28.909 C45.647,30.792 44.706,31.733 44.706,33.615 C43.765,35.497 43.765,36.438 42.823,37.379 C41.882,38.32 40.941,40.202 40,41.143 C39.059,42.084 37.177,43.025 36.235,43.966 C35.294,44.907 33.412,45.848 32.471,45.848 C30.588,46.789 29.647,46.789 27.765,46.789 C25.882,46.789 24.941,46.789 23.059,46.789 Z",
    id: "path-185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,47.895 L24.059,47.895 C10.882,47.895 0.529,37.543 0.529,24.368 C0.529,11.194 10.882,0.842 24.059,0.842 L118.177,0.842 C131.353,0.842 141.706,11.194 141.706,24.368 C141.706,37.543 131.353,47.895 118.177,47.895 Z",
    id: "path-187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.353,47.895 L24.177,47.895 C11,47.895 0.647,37.543 0.647,24.368 C0.647,11.194 11,0.842 24.177,0.842 L165.353,0.842 C178.53,0.842 188.882,11.194 188.882,24.368 C188.882,37.543 178.53,47.895 165.353,47.895 Z",
    id: "path-189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.412,45.895 C22.529,45.895 21.588,45.895 19.706,45.895 C17.824,45.895 16.882,44.954 15,44.954 C13.118,44.013 12.177,44.013 11.235,43.072 C10.294,42.131 8.412,41.189 7.471,40.248 C2.765,35.543 0.882,29.897 0.882,23.309 C0.882,16.722 3.706,11.076 7.471,6.371 C8.412,5.429 10.294,4.488 11.235,3.547 C12.177,2.606 14.059,1.665 15,1.665 C16.882,0.724 17.824,0.724 19.706,0.724 C22.529,-0.217 26.294,-0.217 29.118,0.724 C31,0.724 31.941,1.665 33.823,1.665 C35.706,1.665 36.647,2.606 37.588,3.547 C38.53,4.488 40.412,5.429 41.353,6.371 C42.294,7.312 43.235,9.194 44.177,10.135 C45.118,11.076 46.059,12.958 46.059,13.899 C47,15.781 47,16.722 47,18.604 C47,20.486 47.941,21.427 47.941,23.309 C47.941,25.192 47.941,26.133 47,28.015 C47,29.897 46.059,30.838 46.059,32.72 C45.118,34.602 45.118,35.543 44.177,36.484 C43.235,37.425 42.294,39.307 41.353,40.248 C36.647,43.072 31,45.895 24.412,45.895 Z",
    id: "path-191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.235,47.895 L24.471,47.895 C11.294,47.895 0.941,37.543 0.941,24.368 C0.941,11.194 11.294,0.842 24.471,0.842 L636.235,0.842 C649.412,0.842 659.765,11.194 659.765,24.368 C659.765,37.543 649.412,47.895 636.235,47.895 Z",
    id: "path-193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.294,45.895 C21.412,45.895 20.471,45.895 18.588,45.895 C16.706,45.895 15.765,44.954 13.882,44.954 C12,44.013 11.059,44.013 10.118,43.072 C9.177,42.131 7.294,41.189 6.353,40.248 C5.412,39.307 4.471,37.425 3.529,36.484 C2.588,35.543 1.647,33.661 1.647,32.72 C0.706,31.779 0.706,29.897 0.706,28.015 C0.706,26.133 0.706,25.192 0.706,23.309 C0.706,21.427 0.706,20.486 0.706,18.604 C0.706,16.722 1.647,15.781 1.647,13.899 C2.588,12.958 2.588,11.076 3.529,10.135 C4.471,9.194 5.412,7.312 6.353,6.371 C7.294,5.429 9.177,4.488 10.118,3.547 C11.059,2.606 12.941,1.665 13.882,1.665 C14.823,0.724 16.706,0.724 18.588,0.724 C21.412,-0.217 25.177,-0.217 28,0.724 C29.882,0.724 30.823,1.665 32.706,1.665 C34.588,1.665 35.529,2.606 36.471,3.547 C37.412,4.488 39.294,5.429 40.235,6.371 C44.941,11.076 46.823,16.722 46.823,23.309 C46.823,29.897 44,35.543 40.235,40.248 C39.294,41.189 37.412,42.131 36.471,43.072 C35.529,44.013 33.647,44.954 32.706,44.954 C31.765,45.895 29.882,45.895 28,45.895 C26.118,45.895 25.177,45.895 23.294,45.895 Z",
    id: "path-195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.706,47.895 L24.353,47.895 C11.177,47.895 0.823,37.543 0.823,24.368 C0.823,11.194 11.177,0.842 24.353,0.842 L306.706,0.842 C319.882,0.842 330.235,11.194 330.235,24.368 C330.235,37.543 319.882,47.895 306.706,47.895 Z",
    id: "path-197"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.765,45.895 C21.882,45.895 20.941,45.895 19.059,45.895 C17.177,45.895 16.235,44.954 14.353,44.954 C12.471,44.013 11.529,44.013 10.588,43.072 C9.647,42.131 7.765,41.189 6.823,40.248 C2.118,35.543 0.235,29.897 0.235,23.309 C0.235,21.427 0.235,20.486 0.235,18.604 C0.235,16.722 1.177,15.781 1.177,13.899 C2.118,12.958 2.118,11.076 3.059,10.135 C4,9.194 4.941,7.312 5.882,6.371 C6.823,5.429 7.765,4.488 9.647,3.547 C10.588,2.606 12.471,1.665 13.412,1.665 C14.353,0.724 16.235,0.724 18.118,0.724 C20.941,-0.217 24.706,-0.217 27.529,0.724 C29.412,0.724 30.353,1.665 32.235,1.665 C34.118,1.665 35.059,2.606 36,3.547 C36.941,4.488 38.823,5.429 39.765,6.371 C44.471,11.076 46.353,16.722 46.353,23.309 C46.353,29.897 43.529,35.543 39.765,40.248 C38.823,41.189 36.941,42.131 36,43.072 C35.059,44.013 33.177,44.954 32.235,44.954 C31.294,45.895 29.412,45.895 27.529,45.895 C26.588,45.895 25.647,45.895 23.765,45.895 Z",
    id: "path-199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,47.895 L23.882,47.895 C10.706,47.895 0.353,37.543 0.353,24.368 C0.353,11.194 10.706,0.842 23.882,0.842 L118,0.842 C131.177,0.842 141.529,11.194 141.529,24.368 C141.529,37.543 131.177,47.895 118,47.895 Z",
    id: "path-201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.059,45.895 C21.177,45.895 20.235,45.895 18.353,45.895 C16.471,45.895 15.529,44.954 13.647,44.954 C11.765,44.013 10.823,44.013 9.882,43.072 C8.941,42.131 7.059,41.189 6.118,40.248 C5.177,39.307 4.235,37.425 3.294,36.484 C2.353,35.543 1.412,33.661 1.412,32.72 C0.471,31.779 0.471,29.897 0.471,28.015 C0.471,26.133 0.471,25.192 0.471,23.309 C0.471,21.427 0.471,20.486 0.471,18.604 C0.471,16.722 1.412,15.781 1.412,13.899 C2.353,12.958 2.353,11.076 3.294,10.135 C4.235,9.194 5.177,7.312 6.118,6.371 C7.059,5.429 8.941,4.488 9.882,3.547 C10.823,2.606 12.706,1.665 13.647,1.665 C14.588,0.724 16.471,0.724 18.353,0.724 C21.177,-0.217 24.941,-0.217 27.765,0.724 C29.647,0.724 30.588,1.665 32.471,1.665 C33.412,2.606 35.294,2.606 36.235,3.547 C37.177,4.488 39.059,5.429 40,6.371 C40.941,7.312 41.882,9.194 42.823,10.135 C43.765,11.076 44.706,12.958 44.706,13.899 C45.647,15.781 45.647,16.722 45.647,18.604 C45.647,20.486 45.647,21.427 45.647,23.309 C45.647,25.192 45.647,26.133 45.647,28.015 C45.647,29.897 44.706,30.838 44.706,32.72 C43.765,34.602 43.765,35.543 42.823,36.484 C41.882,37.425 40.941,39.307 40,40.248 C39.059,41.189 37.177,42.131 36.235,43.072 C35.294,44.013 33.412,44.954 32.471,44.954 C30.588,45.895 29.647,45.895 27.765,45.895 C25.882,45.895 24.941,45.895 23.059,45.895 Z",
    id: "path-203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.177,48 L24.059,48 C10.882,48 0.529,37.648 0.529,24.474 C0.529,11.299 10.882,0.947 24.059,0.947 L118.177,0.947 C131.353,0.947 141.706,11.299 141.706,24.474 C141.706,37.648 131.353,48 118.177,48 Z",
    id: "path-205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.882,47.053 C22,47.053 21.059,47.053 19.176,47.053 C17.294,47.053 16.353,46.112 14.471,46.112 C12.588,45.17 11.647,45.17 10.706,44.229 C9.765,43.288 7.882,42.347 6.941,41.406 C3.177,35.76 0.353,30.114 0.353,23.526 C0.353,16.939 3.177,11.293 6.941,6.587 C7.882,5.646 9.765,4.705 10.706,3.764 C11.647,2.823 13.529,1.882 14.471,1.882 C15.412,0.941 17.294,0.941 19.176,0.941 C22,-2.77555756e-17 25.765,-2.77555756e-17 28.588,0.941 C30.471,0.941 31.412,1.882 33.294,1.882 C35.177,1.882 36.118,2.823 37.059,3.764 C38,4.705 39.882,5.646 40.824,6.587 C45.529,11.293 47.412,16.939 47.412,23.526 C47.412,30.114 44.588,35.76 40.824,40.465 C39.882,41.406 38,42.347 37.059,43.288 C36.118,44.229 34.235,45.17 33.294,45.17 C32.353,45.17 30.471,46.112 28.588,46.112 C26.706,47.053 25.765,47.053 23.882,47.053 Z",
    id: "path-207"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.882,48.158 C17.294,48.158 11.647,45.335 6.941,41.571 C3.177,36.865 0.353,31.219 0.353,24.632 C0.353,18.044 3.177,12.398 6.941,7.693 C12.588,2.046 20.118,0.164 28.588,1.105 C30.471,1.105 31.412,2.046 33.294,2.046 C35.177,2.046 36.118,2.987 37.059,3.929 C38,4.869 39.882,5.811 40.824,6.751 C45.529,11.457 47.412,17.103 47.412,23.69 C47.412,30.278 44.588,35.924 40.824,40.629 C39.882,41.571 38.941,42.511 37.059,43.453 C36.118,44.394 34.235,45.335 33.294,45.335 C32.353,45.335 30.471,46.276 28.588,46.276 C26.706,48.158 25.765,48.158 23.882,48.158 Z",
    id: "path-209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.882,47.263 C22,47.263 21.059,47.263 19.176,47.263 C17.294,47.263 16.353,46.322 14.471,46.322 C12.588,45.381 11.647,45.381 10.706,44.44 C9.765,43.499 7.882,42.558 6.941,41.617 C3.177,35.97 0.353,30.324 0.353,23.737 C0.353,17.149 3.177,11.503 6.941,6.798 C7.882,5.857 9.765,4.916 10.706,3.975 C11.647,3.034 13.529,2.093 14.471,2.093 C15.412,1.152 17.294,1.152 19.176,1.152 C26.706,-0.73 35.177,2.093 40.824,7.739 C45.529,12.444 47.412,18.091 47.412,24.678 C47.412,31.265 44.588,36.912 40.824,41.617 C36.118,44.44 30.471,47.263 23.882,47.263 Z",
    id: "path-211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.882,47.368 C21,47.368 20.059,47.368 18.176,47.368 C16.294,47.368 15.353,46.427 13.471,46.427 C11.588,45.486 10.647,45.486 9.706,44.545 C8.765,43.604 6.882,42.663 5.941,41.722 C5,40.781 4.059,38.899 3.118,37.958 C2.177,37.017 1.235,35.135 1.235,34.194 C1.235,33.253 0.294,31.371 0.294,29.489 C0.294,27.606 0.294,26.665 0.294,24.783 C0.294,18.196 3.118,12.55 6.882,7.844 C12.529,2.198 20.059,-0.625 28.53,1.257 C30.412,1.257 31.353,2.198 33.235,2.198 C35.118,2.198 36.059,3.139 37,4.08 C37.941,5.021 39.824,5.962 40.765,6.903 C41.706,7.844 42.647,9.726 43.588,10.667 C44.529,11.608 45.471,13.491 45.471,14.432 C46.412,16.314 46.412,17.255 46.412,19.137 C46.412,21.019 47.353,21.96 47.353,23.842 C47.353,30.429 44.529,36.076 40.765,40.781 C35.118,44.545 29.471,47.368 22.882,47.368 Z",
    id: "path-213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.882,47.474 C17.294,47.474 11.647,44.651 6.941,40.886 C3.177,36.181 0.353,30.535 0.353,23.947 C0.353,17.36 3.177,11.714 6.941,7.008 C15.412,-1.461 31.412,-1.461 39.882,7.008 C44.588,11.714 46.471,17.36 46.471,23.947 C46.471,30.535 43.647,36.181 39.882,40.886 C36.118,44.651 30.471,47.474 23.882,47.474 Z",
    id: "path-215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.882,47.579 C16.294,47.579 10.647,44.756 5.941,40.992 C5,40.051 4.059,38.168 3.118,37.227 C2.177,36.286 1.235,34.404 1.235,33.463 C1.235,32.522 0.294,30.64 0.294,28.758 C0.294,26.876 0.294,25.935 0.294,24.053 C0.294,17.465 3.118,11.819 6.882,7.114 C15.353,-1.356 31.353,-1.356 39.824,7.114 C40.765,8.055 41.706,9.937 42.647,10.878 C43.588,11.819 44.529,13.701 44.529,14.642 C45.471,15.583 45.471,17.465 45.471,19.347 C45.471,21.229 46.412,22.17 46.412,24.053 C46.412,25.935 46.412,26.876 45.471,28.758 C45.471,30.64 44.529,31.581 44.529,33.463 C43.588,34.404 43.588,36.286 42.647,37.227 C41.706,38.168 40.765,40.051 39.824,40.992 C35.118,44.756 29.471,47.579 22.882,47.579 Z",
    id: "path-217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.882,47.684 C16.294,47.684 10.647,44.861 5.941,41.097 C5,40.156 4.059,38.274 3.118,37.333 C2.177,36.392 1.235,34.51 1.235,33.568 C1.235,32.627 0.294,30.745 0.294,28.863 C0.294,26.981 0.294,26.04 0.294,24.158 C0.294,22.276 0.294,21.335 0.294,19.453 C0.294,17.571 1.235,16.629 1.235,14.747 C2.177,13.806 2.177,11.924 3.118,10.983 C4.059,10.042 5,8.16 5.941,7.219 C14.412,-1.25 30.412,-1.25 38.882,7.219 C39.824,8.16 40.765,10.042 41.706,10.983 C42.647,11.924 43.588,13.806 43.588,14.747 C44.529,16.629 44.529,17.571 44.529,19.453 C44.529,21.335 45.471,22.276 45.471,24.158 C45.471,26.04 45.471,26.981 44.529,28.863 C44.529,30.745 43.588,31.686 43.588,33.568 C42.647,34.51 42.647,36.392 41.706,37.333 C40.765,38.274 39.824,40.156 38.882,41.097 C35.118,44.861 29.471,47.684 22.882,47.684 Z",
    id: "path-219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.882,45.79 C21,45.79 20.059,45.79 18.176,45.79 C16.294,45.79 15.353,44.848 13.471,44.848 C11.588,43.908 10.647,43.908 9.706,42.966 C8.765,42.025 6.882,41.084 5.941,40.143 C5,39.202 4.059,37.32 3.118,36.379 C2.177,35.438 1.235,33.556 1.235,32.615 C1.235,31.674 0.294,29.792 0.294,27.909 C0.294,26.027 0.294,25.086 0.294,23.204 C0.294,16.617 3.118,10.97 6.882,6.265 C7.823,5.324 9.706,4.383 10.647,3.442 C11.588,2.501 13.471,1.56 14.412,1.56 C15.353,0.619 17.235,0.619 19.118,0.619 C26.647,-1.263 35.118,1.56 40.765,7.206 C45.471,11.912 47.353,17.558 47.353,24.145 C47.353,26.027 47.353,26.969 46.412,28.851 C46.412,30.733 45.471,31.674 45.471,33.556 C44.529,34.497 44.529,36.379 43.588,37.32 C42.647,38.261 41.706,40.143 40.765,41.084 C35.118,42.966 29.471,45.79 22.882,45.79 Z",
    id: "path-221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.882,45.895 C21,45.895 20.059,45.895 18.176,45.895 C16.294,45.895 15.353,44.954 13.471,44.954 C11.588,44.013 10.647,44.013 9.706,43.072 C8.765,42.131 6.882,41.189 5.941,40.249 C5,39.307 4.059,38.366 3.118,36.484 C2.177,35.543 1.235,33.661 1.235,32.72 C1.235,31.779 0.294,29.897 0.294,28.015 C0.294,26.133 0.294,25.192 0.294,23.31 C0.294,21.428 0.294,20.486 0.294,18.604 C0.294,16.722 1.235,15.781 1.235,13.899 C2.177,12.958 2.177,11.076 3.118,10.135 C4.059,9.194 5,7.312 5.941,6.371 C6.882,5.429 8.765,4.489 9.706,3.547 C10.647,2.606 12.529,1.665 13.471,1.665 C14.412,0.724 16.294,0.724 18.176,0.724 C21,-0.217 23.823,-0.217 27.588,0.724 C29.471,0.724 30.412,1.665 32.294,1.665 C34.177,1.665 35.118,2.606 36.059,3.547 C37,4.489 38.882,5.429 39.824,6.371 C40.765,7.312 41.706,9.194 42.647,10.135 C43.588,11.076 44.529,12.958 44.529,13.899 C45.471,15.781 45.471,16.722 45.471,18.604 C45.471,20.486 46.412,21.428 46.412,23.31 C46.412,29.897 43.588,35.543 39.824,40.249 C38.882,41.189 37,42.131 36.059,43.072 C35.118,44.013 33.235,44.954 32.294,44.954 C31.353,44.954 29.471,45.895 27.588,45.895 C25.706,45.895 24.765,45.895 22.882,45.895 Z",
    id: "path-223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,48 L23.823,48 C10.647,48 0.294,37.648 0.294,24.474 C0.294,11.299 10.647,0.947 23.823,0.947 L70.882,0.947 C84.059,0.947 94.412,11.299 94.412,24.474 C94.412,37.648 84.059,48 70.882,48 Z",
    id: "path-225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.105 L23.823,47.105 C10.647,47.105 0.294,36.754 0.294,23.579 C0.294,10.404 10.647,0.053 23.823,0.053 L70.882,0.053 C84.059,0.053 94.412,10.404 94.412,23.579 C94.412,36.754 84.059,47.105 70.882,47.105 Z",
    id: "path-227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.21 L23.823,47.21 C10.647,47.21 0.294,36.859 0.294,23.684 C0.294,10.51 10.647,0.158 23.823,0.158 L70.882,0.158 C84.059,0.158 94.412,10.51 94.412,23.684 C94.412,36.859 84.059,47.21 70.882,47.21 Z",
    id: "path-229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.316 L23.823,47.316 C10.647,47.316 0.294,36.964 0.294,23.79 C0.294,10.615 10.647,0.263 23.823,0.263 L70.882,0.263 C84.059,0.263 94.412,10.615 94.412,23.79 C94.412,36.964 84.059,47.316 70.882,47.316 Z",
    id: "path-231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.421 L23.823,47.421 C10.647,47.421 0.294,37.07 0.294,23.895 C0.294,10.72 10.647,0.368 23.823,0.368 L70.882,0.368 C84.059,0.368 94.412,10.72 94.412,23.895 C94.412,37.07 84.059,47.421 70.882,47.421 Z",
    id: "path-233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.526 L23.823,47.526 C10.647,47.526 0.294,37.175 0.294,24 C0.294,10.825 10.647,0.474 23.823,0.474 L70.882,0.474 C84.059,0.474 94.412,10.825 94.412,24 C94.412,37.175 84.059,47.526 70.882,47.526 Z",
    id: "path-235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.632 L23.823,47.632 C10.647,47.632 0.294,37.28 0.294,24.105 C0.294,10.931 10.647,0.579 23.823,0.579 L70.882,0.579 C84.059,0.579 94.412,10.931 94.412,24.105 C94.412,37.28 84.059,47.632 70.882,47.632 Z",
    id: "path-237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.737 L23.823,47.737 C10.647,47.737 0.294,37.385 0.294,24.211 C0.294,11.036 10.647,0.684 23.823,0.684 L70.882,0.684 C84.059,0.684 94.412,11.036 94.412,24.211 C94.412,37.385 84.059,47.737 70.882,47.737 Z",
    id: "path-239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.842 L23.823,47.842 C10.647,47.842 0.294,37.491 0.294,24.316 C0.294,11.141 10.647,0.789 23.823,0.789 L70.882,0.789 C84.059,0.789 94.412,11.141 94.412,24.316 C94.412,37.491 84.059,47.842 70.882,47.842 Z",
    id: "path-241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.947 L23.823,47.947 C10.647,47.947 0.294,37.596 0.294,24.421 C0.294,11.246 10.647,0.895 23.823,0.895 L70.882,0.895 C84.059,0.895 94.412,11.246 94.412,24.421 C94.412,37.596 84.059,47.947 70.882,47.947 Z",
    id: "path-243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.053 L23.823,47.053 C10.647,47.053 0.294,36.701 0.294,23.526 C0.294,10.352 10.647,0 23.823,0 L70.882,0 C84.059,0 94.412,10.352 94.412,23.526 C94.412,36.701 84.059,47.053 70.882,47.053 Z",
    id: "path-245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.158 L23.823,47.158 C10.647,47.158 0.294,36.806 0.294,23.632 C0.294,10.457 10.647,0.105 23.823,0.105 L70.882,0.105 C84.059,0.105 94.412,10.457 94.412,23.632 C94.412,36.806 84.059,47.158 70.882,47.158 Z",
    id: "path-247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.263 L23.823,47.263 C10.647,47.263 0.294,36.912 0.294,23.737 C0.294,10.562 10.647,0.211 23.823,0.211 L70.882,0.211 C84.059,0.211 94.412,10.562 94.412,23.737 C94.412,36.912 84.059,47.263 70.882,47.263 Z",
    id: "path-249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.368 L23.823,47.368 C10.647,47.368 0.294,37.017 0.294,23.842 C0.294,10.667 10.647,0.316 23.823,0.316 L70.882,0.316 C84.059,0.316 94.412,10.667 94.412,23.842 C94.412,37.017 84.059,47.368 70.882,47.368 Z",
    id: "path-251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.474 L23.823,47.474 C10.647,47.474 0.294,37.122 0.294,23.947 C0.294,10.773 10.647,0.421 23.823,0.421 L70.882,0.421 C84.059,0.421 94.412,10.773 94.412,23.947 C94.412,37.122 84.059,47.474 70.882,47.474 Z",
    id: "path-253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.579 L23.823,47.579 C10.647,47.579 0.294,37.227 0.294,24.053 C0.294,10.878 10.647,0.526 23.823,0.526 L70.882,0.526 C84.059,0.526 94.412,10.878 94.412,24.053 C94.412,37.227 84.059,47.579 70.882,47.579 Z",
    id: "path-255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.684 L23.823,47.684 C10.647,47.684 0.294,37.333 0.294,24.158 C0.294,10.983 10.647,0.632 23.823,0.632 L70.882,0.632 C84.059,0.632 94.412,10.983 94.412,24.158 C94.412,37.333 84.059,47.684 70.882,47.684 Z",
    id: "path-257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.789 L23.823,47.789 C10.647,47.789 0.294,37.438 0.294,24.263 C0.294,11.089 10.647,0.737 23.823,0.737 L70.882,0.737 C84.059,0.737 94.412,11.089 94.412,24.263 C94.412,37.438 84.059,47.789 70.882,47.789 Z",
    id: "path-259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,47.895 L23.823,47.895 C10.647,47.895 0.294,37.543 0.294,24.368 C0.294,11.194 10.647,0.842 23.823,0.842 L70.882,0.842 C84.059,0.842 94.412,11.194 94.412,24.368 C94.412,37.543 84.059,47.895 70.882,47.895 Z",
    id: "path-261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.882,48 L23.823,48 C10.647,48 0.294,37.648 0.294,24.474 C0.294,11.299 10.647,0.947 23.823,0.947 L70.882,0.947 C84.059,0.947 94.412,11.299 94.412,24.474 C94.412,37.648 84.059,48 70.882,48 Z",
    id: "path-263"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0441ode-on-screen-flat-illustration-eps-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#16202A",
    mask: "url(#mask-2)",
    points: "0.06 4000 4000.02 4000 4000.02 0.04 0.06 0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(541.000000, 659.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#F87484",
    mask: "url(#mask-4)",
    points: "0.5 47.12 424.1 47.12 424.1 -0.04 0.5 -0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(965.000000, 659.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#D1D5DA",
    mask: "url(#mask-6)",
    points: "-0.02 47.12 188.38 47.12 188.38 -0.04 -0.02 -0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(541.000000, 847.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#F87484",
    mask: "url(#mask-8)",
    points: "0.5 47.28 377.06 47.28 377.06 0.12 0.5 0.12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(918.000000, 846.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#D1D5DA",
    mask: "url(#mask-10)",
    points: "0.9 48.28 47.1 48.28 47.1 0.88 0.9 0.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(541.000000, 941.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#D1D5DA",
    mask: "url(#mask-12)",
    points: "0.5 47.48 141.74 47.48 141.74 0.2 0.5 0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(635.000000, 941.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#FFA870",
    mask: "url(#mask-14)",
    points: "0.58 47.48 706.54 47.48 706.54 0.2 0.58 0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(541.000000, 1035.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#D1D5DA",
    mask: "url(#mask-16)",
    points: "0.5 47.56 141.74 47.56 141.74 0.4 0.5 0.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(635.000000, 1035.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#FFA870",
    mask: "url(#mask-18)",
    points: "0.58 47.56 236.02 47.56 236.02 0.4 0.58 0.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(541.000000, 1129.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-29"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#D1D5DA",
    mask: "url(#mask-20)",
    points: "0.5 47.64 141.74 47.64 141.74 0.48 0.5 0.48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(635.000000, 1129.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#FFA870",
    mask: "url(#mask-22)",
    points: "0.58 47.64 471.34 47.64 471.34 0.48 0.58 0.48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(541.000000, 1223.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#D1D5DA",
    mask: "url(#mask-24)",
    points: "0.5 47.72 141.74 47.72 141.74 0.56 0.5 0.56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(541.000000, 1411.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-38"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#F87484",
    mask: "url(#mask-26)",
    points: "0.5 48 282.98 48 282.98 0.84 0.5 0.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(823.000000, 1411.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#D1D5DA",
    mask: "url(#mask-28)",
    points: "0.86 48 518.54 48 518.54 0.84 0.86 0.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(1388.000000, 1411.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#F87484",
    mask: "url(#mask-30)",
    points: "0.58 48 283.06 48 283.06 0.84 0.58 0.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(1718.000000, 1413.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#D1D5DA",
    mask: "url(#mask-32)",
    points: "0.94 46 47.14 46 47.14 -0.08 0.94 -0.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-51",
    transform: "translate(541.000000, 1505.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-50"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#D1D5DA",
    mask: "url(#mask-34)",
    points: "0.5 48.08 141.74 48.08 141.74 0.92 0.5 0.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    transform: "translate(635.000000, 1505.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#74BBFF",
    mask: "url(#mask-36)",
    points: "0.58 48.08 188.98 48.08 188.98 0.92 0.58 0.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-57",
    transform: "translate(870.000000, 1505.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#D1D5DA",
    mask: "url(#mask-38)",
    points: "0.9 48.08 283.38 48.08 283.38 0.92 0.9 0.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(541.000000, 1600.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-59"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#D1D5DA",
    mask: "url(#mask-40)",
    points: "0.5 47.16 141.74 47.16 141.74 0 0.5 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-63",
    transform: "translate(541.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-42",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-62"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-61",
    fill: "#F87484",
    mask: "url(#mask-42)",
    points: "0.5 47.32 282.98 47.32 282.98 0.16 0.5 0.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-66",
    transform: "translate(823.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-44",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#AF95F1",
    mask: "url(#mask-44)",
    points: "0.86 47.32 518.54 47.32 518.54 0.16 0.86 0.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-69",
    transform: "translate(1341.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-46",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-67",
    fill: "#D1D5DA",
    mask: "url(#mask-46)",
    points: "0.42 47.32 46.74 47.32 46.74 0.4 0.42 0.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-72",
    transform: "translate(1388.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#D1D5DA",
    mask: "url(#mask-48)",
    points: "0.58 47.32 94.78 47.32 94.78 0.16 0.58 0.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-75",
    transform: "translate(1529.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-50",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-74"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-73",
    fill: "#D1D5DA",
    mask: "url(#mask-50)",
    points: "0.7 47.32 236.14 47.32 236.14 0.16 0.7 0.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-78",
    transform: "translate(1765.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-52",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-77"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    fill: "#D1D5DA",
    mask: "url(#mask-52)",
    points: "0.02 47.32 658.94 47.32 658.94 0.16 0.02 0.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-81",
    transform: "translate(2423.000000, 1789.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-54",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-80"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-79",
    fill: "#D1D5DA",
    mask: "url(#mask-54)",
    points: "0.82 46.32 46.06 46.32 46.06 0.36 0.82 0.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-84",
    transform: "translate(2518.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-56",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-83"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-82",
    fill: "#D1D5DA",
    mask: "url(#mask-56)",
    points: "-0.1 47.32 329.42 47.32 329.42 0.16 -0.1 0.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-87",
    transform: "translate(2894.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-58",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-86"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-85",
    fill: "#74BBFF",
    mask: "url(#mask-58)",
    points: "0.46 47.32 47.62 47.32 47.62 0.4 0.46 0.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-90",
    transform: "translate(2941.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-60",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-89"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-88",
    fill: "#D1D5DA",
    mask: "url(#mask-60)",
    points: "0.5 47.32 235.94 47.32 235.94 0.16 0.5 0.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-93",
    transform: "translate(3176.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-62",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-91",
    fill: "#D1D5DA",
    mask: "url(#mask-62)",
    points: "0.82 47.32 330.34 47.32 330.34 0.16 0.82 0.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-96",
    transform: "translate(3507.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-64",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-95"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-94",
    fill: "#D1D5DA",
    mask: "url(#mask-64)",
    points: "0.06 47.32 45.42 47.32 45.42 0.64 0.06 0.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-99",
    transform: "translate(3601.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-66",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-98"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-97",
    fill: "#D1D5DA",
    mask: "url(#mask-66)",
    points: "0.26 47.32 45.5 47.32 45.5 0.04 0.26 0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-102",
    transform: "translate(541.000000, 1882.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-68",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-101"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-100",
    fill: "#D1D5DA",
    mask: "url(#mask-68)",
    points: "0.5 47.52 141.74 47.52 141.74 0.36 0.5 0.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-105",
    transform: "translate(635.000000, 1882.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-70",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-104"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-103",
    fill: "#D1D5DA",
    mask: "url(#mask-70)",
    points: "0.58 47.52 330.1 47.52 330.1 0.36 0.58 0.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-108",
    transform: "translate(1012.000000, 1882.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-72",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-107"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-106",
    fill: "#74BBFF",
    mask: "url(#mask-72)",
    points: "0.02 47.52 94.34 47.52 94.34 0.36 0.02 0.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-111",
    transform: "translate(1153.000000, 1882.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-74",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-110"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-109",
    fill: "#D1D5DA",
    mask: "url(#mask-74)",
    points: "0.26 47.52 188.54 47.52 188.54 0.36 0.26 0.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-114",
    transform: "translate(1342.000000, 1883.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-76",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-113"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-112",
    fill: "#D1D5DA",
    mask: "url(#mask-76)",
    points: "0.38 46.52 46.7 46.52 46.7 0.08 0.38 0.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-117",
    transform: "translate(1388.000000, 1882.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-78",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-116"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-115",
    fill: "#AF95F1",
    mask: "url(#mask-78)",
    points: "0.58 47.52 471.22 47.52 471.22 0.36 0.58 0.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-120",
    transform: "translate(1859.000000, 1883.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-80",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-119"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-118",
    fill: "#D1D5DA",
    mask: "url(#mask-80)",
    points: "0.1 47.48 46.3 47.48 46.3 0.68 0.1 0.68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-123",
    transform: "translate(1906.000000, 1882.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-82",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-122"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-121",
    fill: "#D1D5DA",
    mask: "url(#mask-82)",
    points: "0.14 47.52 329.66 47.52 329.66 0.36 0.14 0.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-126",
    transform: "translate(2236.000000, 1882.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-84",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-124",
    fill: "#D1D5DA",
    mask: "url(#mask-84)",
    points: "0.5 47.52 44.9 47.52 44.9 0.6 0.5 0.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-129",
    transform: "translate(2282.000000, 1882.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-86",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-128"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-127",
    fill: "#74BBFF",
    mask: "url(#mask-86)",
    points: "0.7 47.52 188.98 47.52 188.98 0.36 0.7 0.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-132",
    transform: "translate(2471.000000, 1883.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-88",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-131"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-130",
    fill: "#D1D5DA",
    mask: "url(#mask-88)",
    points: "0.82 46.52 46.06 46.52 46.06 0.44 0.82 0.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-135",
    transform: "translate(541.000000, 2070.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-90",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-134"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-133",
    fill: "#D1D5DA",
    mask: "url(#mask-90)",
    points: "0.5 47.68 141.74 47.68 141.74 0.52 0.5 0.52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-138",
    transform: "translate(635.000000, 2070.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-92",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-137"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-136",
    fill: "#F87484",
    mask: "url(#mask-92)",
    points: "0.58 47.68 141.94 47.68 141.94 0.52 0.58 0.52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-141",
    transform: "translate(823.000000, 2070.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-94",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-140"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-139",
    fill: "#D1D5DA",
    mask: "url(#mask-94)",
    points: "0.86 47.68 47.06 47.68 47.06 0.28 0.86 0.28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-144",
    transform: "translate(918.000000, 2070.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-96",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-95"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-143"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-142",
    fill: "#D1D5DA",
    mask: "url(#mask-96)",
    points: "-0.06 47.68 517.74 47.68 517.74 0.52 -0.06 0.52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-147",
    transform: "translate(541.000000, 2164.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-98",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-146"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-145",
    fill: "#D1D5DA",
    mask: "url(#mask-98)",
    points: "0.5 47.76 141.74 47.76 141.74 0.6 0.5 0.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-150",
    transform: "translate(635.000000, 2164.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-100",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-149"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-148",
    fill: "#D1D5DA",
    mask: "url(#mask-100)",
    points: "0.58 47.76 141.94 47.76 141.94 0.6 0.58 0.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-153",
    transform: "translate(823.000000, 2164.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-102",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-152"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-151",
    fill: "#74BBFF",
    mask: "url(#mask-102)",
    points: "0.86 47.76 95.06 47.76 95.06 0.6 0.86 0.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-156",
    transform: "translate(965.000000, 2164.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-104",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-103"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-155"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-154",
    fill: "#D1D5DA",
    mask: "url(#mask-104)",
    points: "-0.02 47.76 329.5 47.76 329.5 0.6 -0.02 0.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-159",
    transform: "translate(1295.000000, 2165.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-106",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-158"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-157",
    fill: "#D1D5DA",
    mask: "url(#mask-106)",
    points: "0.34 46.76 47.5 46.76 47.5 0.92 0.34 0.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-162",
    transform: "translate(1341.000000, 2164.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-108",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-107"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-161"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-160",
    fill: "#AF95F1",
    mask: "url(#mask-108)",
    points: "0.42 47.76 282.9 47.76 282.9 0.6 0.42 0.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-165",
    transform: "translate(1623.000000, 2165.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-110",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-109"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-164"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-163",
    fill: "#D1D5DA",
    mask: "url(#mask-110)",
    points: "0.78 46.76 48.06 46.76 48.06 -0.04 0.78 -0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-168",
    transform: "translate(1671.000000, 2164.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-112",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-167"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-166",
    fill: "#74BBFF",
    mask: "url(#mask-112)",
    points: "0.78 47.76 48.06 47.76 48.06 0.84 0.78 0.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-171",
    transform: "translate(1718.000000, 2165.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-114",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-113"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-170"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-169",
    fill: "#D1D5DA",
    mask: "url(#mask-114)",
    points: "0.94 46.76 47.14 46.76 47.14 0.8 0.94 0.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-174",
    transform: "translate(1765.000000, 2165.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-116",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-115"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-173"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-172",
    fill: "#D1D5DA",
    mask: "url(#mask-116)",
    points: "0.02 46.76 47.18 46.76 47.18 0.8 0.02 0.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-177",
    transform: "translate(541.000000, 2352.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-118",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-117"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-175",
    fill: "#D1D5DA",
    mask: "url(#mask-118)",
    points: "0.5 48.04 141.74 48.04 141.74 0.88 0.5 0.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-180",
    transform: "translate(635.000000, 2352.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-120",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-119"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-179"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-178",
    fill: "#F87484",
    mask: "url(#mask-120)",
    points: "0.58 48.04 94.78 48.04 94.78 0.88 0.58 0.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-183",
    transform: "translate(776.000000, 2352.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-122",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-182"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-181",
    fill: "#D1D5DA",
    mask: "url(#mask-122)",
    points: "0.82 48.04 142.06 48.04 142.06 0.88 0.82 0.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-186",
    transform: "translate(965.000000, 2352.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-124",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-123"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-185"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-184",
    fill: "#74BBFF",
    mask: "url(#mask-124)",
    points: "-0.02 48.04 94.18 48.04 94.18 0.88 -0.02 0.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-189",
    transform: "translate(1106.000000, 2352.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-126",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-125"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-188"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-187",
    fill: "#74BBFF",
    mask: "url(#mask-126)",
    points: "0.22 48.04 141.46 48.04 141.46 0.88 0.22 0.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-192",
    transform: "translate(1295.000000, 2353.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-128",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-127"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-191"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-190",
    fill: "#D1D5DA",
    mask: "url(#mask-128)",
    points: "0.34 47.04 46.54 47.04 46.54 0.12 0.34 0.12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-195",
    transform: "translate(541.000000, 2447.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-130",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-129"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-194"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-193",
    fill: "#D1D5DA",
    mask: "url(#mask-130)",
    points: "0.5 47.12 188.78 47.12 188.78 -0.04 0.5 -0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-198",
    transform: "translate(682.000000, 2447.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-132",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-131"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-197"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-196",
    fill: "#AF95F1",
    mask: "url(#mask-132)",
    points: "0.62 47.12 236.06 47.12 236.06 -0.04 0.62 -0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-201",
    transform: "translate(918.000000, 2447.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-133"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-200"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-199",
    fill: "#D1D5DA",
    mask: "url(#mask-134)",
    points: "-0.06 47.12 46.14 47.12 46.14 0.32 -0.06 0.32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-204",
    transform: "translate(965.000000, 2447.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-135"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-203"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-202",
    fill: "#D1D5DA",
    mask: "url(#mask-136)",
    points: "-0.02 47.12 141.34 47.12 141.34 -0.04 -0.02 -0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-207",
    transform: "translate(1106.000000, 2447.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-138",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-137"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-206"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-205",
    fill: "#D1D5DA",
    mask: "url(#mask-138)",
    points: "0.22 47.12 47.38 47.12 47.38 0.2 0.22 0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-210",
    transform: "translate(541.000000, 2541.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-140",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-139"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-209"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-208",
    fill: "#D1D5DA",
    mask: "url(#mask-140)",
    points: "0.5 47.2 188.78 47.2 188.78 0.04 0.5 0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-213",
    transform: "translate(541.000000, 2729.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-141"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-212"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-211",
    fill: "#D1D5DA",
    mask: "url(#mask-142)",
    points: "0.5 47.48 141.74 47.48 141.74 0.2 0.5 0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-216",
    transform: "translate(635.000000, 2729.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-144",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-215"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-214",
    fill: "#D1D5DA",
    mask: "url(#mask-144)",
    points: "0.58 47.48 141.94 47.48 141.94 0.2 0.58 0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-219",
    transform: "translate(776.000000, 2729.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-146",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-145"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-217",
    fill: "#D1D5DA",
    mask: "url(#mask-146)",
    points: "0.82 47.48 47.02 47.48 47.02 0.44 0.82 0.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-222",
    transform: "translate(823.000000, 2729.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-148",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-147"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-221"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-220",
    fill: "#AF95F1",
    mask: "url(#mask-148)",
    points: "0.86 47.48 330.38 47.48 330.38 0.2 0.86 0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-225",
    transform: "translate(1153.000000, 2729.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-150",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-149"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-224"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-223",
    fill: "#D1D5DA",
    mask: "url(#mask-150)",
    points: "0.26 47.48 46.46 47.48 46.46 0.44 0.26 0.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-228",
    transform: "translate(1200.000000, 2729.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-152",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-227"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-226",
    fill: "#D1D5DA",
    mask: "url(#mask-152)",
    points: "0.3 47.48 46.5 47.48 46.5 0.44 0.3 0.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-231",
    transform: "translate(1247.000000, 2729.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-154",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-153"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-230"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-229",
    fill: "#D1D5DA",
    mask: "url(#mask-154)",
    points: "0.34 47.48 46.54 47.48 46.54 0.44 0.34 0.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-234",
    transform: "translate(1294.000000, 2729.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-156",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-155"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-233"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-232",
    fill: "#74BBFF",
    mask: "url(#mask-156)",
    points: "0.38 47.48 188.78 47.48 188.78 0.2 0.38 0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-237",
    transform: "translate(1482.000000, 2729.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-158",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-157"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-236"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-235",
    fill: "#D1D5DA",
    mask: "url(#mask-158)",
    points: "0.66 47.48 46.86 47.48 46.86 0.44 0.66 0.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-240",
    transform: "translate(541.000000, 2823.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-160",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-159"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-239"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-238",
    fill: "#D1D5DA",
    mask: "url(#mask-160)",
    points: "0.5 47.56 141.74 47.56 141.74 0.4 0.5 0.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-243",
    transform: "translate(541.000000, 3011.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-162",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-161"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-242"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-241",
    fill: "#F87484",
    mask: "url(#mask-162)",
    points: "0.5 47.72 282.98 47.72 282.98 0.56 0.5 0.56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-246",
    transform: "translate(823.000000, 3011.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-164",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-245"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-244",
    fill: "#AF95F1",
    mask: "url(#mask-164)",
    points: "0.86 47.72 189.14 47.72 189.14 0.56 0.86 0.56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-249",
    transform: "translate(1012.000000, 3011.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-166",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-165"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-248"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-247",
    fill: "#D1D5DA",
    mask: "url(#mask-166)",
    points: "0.02 47.72 94.34 47.72 94.34 0.56 0.02 0.56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-252",
    transform: "translate(1154.000000, 3012.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-168",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-167"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-251"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-250",
    fill: "#D1D5DA",
    mask: "url(#mask-168)",
    points: "0.22 46.72 47.38 46.72 47.38 0.28 0.22 0.28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-255",
    transform: "translate(541.000000, 3105.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-170",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-169"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-254"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-253",
    fill: "#D1D5DA",
    mask: "url(#mask-170)",
    points: "0.5 47.8 141.74 47.8 141.74 0.64 0.5 0.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-258",
    transform: "translate(635.000000, 3105.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-172",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-171"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-257"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-256",
    fill: "#D1D5DA",
    mask: "url(#mask-172)",
    points: "0.58 47.8 188.98 47.8 188.98 0.64 0.58 0.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-261",
    transform: "translate(824.000000, 3105.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-174",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-173"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-260"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-259",
    fill: "#D1D5DA",
    mask: "url(#mask-174)",
    points: "0.82 47.8 47.02 47.8 47.02 0.88 0.82 0.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-264",
    transform: "translate(870.000000, 3105.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-176",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-263"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-262",
    fill: "#AF95F1",
    mask: "url(#mask-176)",
    points: "0.9 47.8 471.54 47.8 471.54 0.64 0.9 0.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-267",
    transform: "translate(1342.000000, 3107.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-178",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-177"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-266"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-265",
    fill: "#D1D5DA",
    mask: "url(#mask-178)",
    points: "0.38 46.76 46.7 46.76 46.7 -0.04 0.38 -0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-270",
    transform: "translate(1388.000000, 3105.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-180",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-179"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-269"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-268",
    fill: "#FFA870",
    mask: "url(#mask-180)",
    points: "0.58 47.8 141.82 47.8 141.82 0.64 0.58 0.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-273",
    transform: "translate(1530.000000, 3105.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-182",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-272"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-271",
    fill: "#D1D5DA",
    mask: "url(#mask-182)",
    points: "0.66 47.8 46.86 47.8 46.86 0.4 0.66 0.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-276",
    transform: "translate(1623.000000, 3105.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-184",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-183"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-274",
    fill: "#D1D5DA",
    mask: "url(#mask-184)",
    points: "0.78 47.8 518.58 47.8 518.58 0.64 0.78 0.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-279",
    transform: "translate(2142.000000, 3106.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-186",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-185"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-278"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-277",
    fill: "#D1D5DA",
    mask: "url(#mask-186)",
    points: "0.42 46.8 45.66 46.8 45.66 0.84 0.42 0.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-282",
    transform: "translate(541.000000, 3199.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-188",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-187"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-281"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-280",
    fill: "#D1D5DA",
    mask: "url(#mask-188)",
    points: "0.5 48 141.74 48 141.74 0.84 0.5 0.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-285",
    transform: "translate(635.000000, 3199.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-189"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-284"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-283",
    fill: "#D1D5DA",
    mask: "url(#mask-190)",
    points: "0.58 48 188.98 48 188.98 0.84 0.58 0.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-288",
    transform: "translate(823.000000, 3201.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-192",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-191"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-287"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-286",
    fill: "#D1D5DA",
    mask: "url(#mask-192)",
    points: "0.86 46 48.02 46 48.02 -0.08 0.86 -0.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-291",
    transform: "translate(870.000000, 3199.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-194",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-193"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-290"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-289",
    fill: "#AF95F1",
    mask: "url(#mask-194)",
    points: "0.9 48 659.82 48 659.82 0.84 0.9 0.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-294",
    transform: "translate(1530.000000, 3201.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-196",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-195"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-293"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-292",
    fill: "#D1D5DA",
    mask: "url(#mask-196)",
    points: "0.66 46 46.86 46 46.86 -0.08 0.66 -0.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-297",
    transform: "translate(1576.000000, 3199.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-198",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-197"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-296"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-295",
    fill: "#FFA870",
    mask: "url(#mask-198)",
    points: "0.74 48 330.26 48 330.26 0.84 0.74 0.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-300",
    transform: "translate(1906.000000, 3201.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-200",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-199"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-299"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-298",
    fill: "#D1D5DA",
    mask: "url(#mask-200)",
    points: "0.14 46 46.46 46 46.46 -0.08 0.14 -0.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-303",
    transform: "translate(2000.000000, 3199.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-202",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-201"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-302"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-301",
    fill: "#74BBFF",
    mask: "url(#mask-202)",
    points: "0.34 48 141.58 48 141.58 0.84 0.34 0.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-306",
    transform: "translate(2142.000000, 3201.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-204",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-203"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-305"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-304",
    fill: "#D1D5DA",
    mask: "url(#mask-204)",
    points: "0.42 46 45.66 46 45.66 -0.08 0.42 -0.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-309",
    transform: "translate(541.000000, 3293.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-206",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-205"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-308"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-307",
    fill: "#D1D5DA",
    mask: "url(#mask-206)",
    points: "0.5 48.08 141.74 48.08 141.74 0.92 0.5 0.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-312",
    transform: "translate(400.000000, 659.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-208",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-207"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-311"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-310",
    fill: "#949DA5",
    mask: "url(#mask-208)",
    points: "0.26 47.12 47.42 47.12 47.42 0.2 0.26 0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-315",
    transform: "translate(400.000000, 752.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-210",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-209"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-314"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-313",
    fill: "#949DA5",
    mask: "url(#mask-210)",
    points: "0.26 48.2 47.42 48.2 47.42 0.8 0.26 0.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-318",
    transform: "translate(400.000000, 847.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-212",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-211"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-317"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-316",
    fill: "#949DA5",
    mask: "url(#mask-212)",
    points: "0.26 47.28 47.42 47.28 47.42 0.48 0.26 0.48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-321",
    transform: "translate(401.000000, 941.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-214",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-213"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-320"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-319",
    fill: "#949DA5",
    mask: "url(#mask-214)",
    points: "0.22 47.48 47.38 47.48 47.38 0.68 0.22 0.68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-324",
    transform: "translate(400.000000, 1035.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-216",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-215"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-323"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-322",
    fill: "#949DA5",
    mask: "url(#mask-216)",
    points: "0.26 47.56 46.58 47.56 46.58 0.64 0.26 0.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-327",
    transform: "translate(401.000000, 1129.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-218",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-217"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-326"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-325",
    fill: "#949DA5",
    mask: "url(#mask-218)",
    points: "0.22 47.64 46.42 47.64 46.42 0.72 0.22 0.72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-330",
    transform: "translate(401.000000, 1223.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-220",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-219"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-329"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-328",
    fill: "#949DA5",
    mask: "url(#mask-220)",
    points: "0.22 47.72 45.58 47.72 45.58 0.8 0.22 0.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-333",
    transform: "translate(401.000000, 1319.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-222",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-221"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-332"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-331",
    fill: "#949DA5",
    mask: "url(#mask-222)",
    points: "0.22 45.8 47.38 45.8 47.38 -0.04 0.22 -0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-336",
    transform: "translate(401.000000, 1413.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-224",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-223"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-335"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-334",
    fill: "#949DA5",
    mask: "url(#mask-224)",
    points: "0.22 46 46.42 46 46.42 -0.08 0.22 -0.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-339",
    transform: "translate(353.000000, 1505.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-226",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-225"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-338"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-337",
    fill: "#949DA5",
    mask: "url(#mask-226)",
    points: "0.22 48.08 94.42 48.08 94.42 0.92 0.22 0.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-342",
    transform: "translate(353.000000, 1600.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-228",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-227"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-341"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-340",
    fill: "#949DA5",
    mask: "url(#mask-228)",
    points: "0.22 47.16 94.42 47.16 94.42 0 0.22 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-345",
    transform: "translate(353.000000, 1694.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-230",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-344"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-343",
    fill: "#949DA5",
    mask: "url(#mask-230)",
    points: "0.22 47.24 94.42 47.24 94.42 0.08 0.22 0.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-348",
    transform: "translate(353.000000, 1788.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-232",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-231"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-347"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-346",
    fill: "#949DA5",
    mask: "url(#mask-232)",
    points: "0.22 47.32 94.42 47.32 94.42 0.16 0.22 0.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-351",
    transform: "translate(353.000000, 1882.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-234",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-233"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-350"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-349",
    fill: "#949DA5",
    mask: "url(#mask-234)",
    points: "0.22 47.52 94.42 47.52 94.42 0.36 0.22 0.36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-354",
    transform: "translate(353.000000, 1976.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-236",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-235"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-352",
    fill: "#949DA5",
    mask: "url(#mask-236)",
    points: "0.22 47.6 94.42 47.6 94.42 0.44 0.22 0.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-357",
    transform: "translate(353.000000, 2070.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-238",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-237"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-356"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-355",
    fill: "#949DA5",
    mask: "url(#mask-238)",
    points: "0.22 47.68 94.42 47.68 94.42 0.52 0.22 0.52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-360",
    transform: "translate(353.000000, 2164.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-240",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-239"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-359"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-358",
    fill: "#949DA5",
    mask: "url(#mask-240)",
    points: "0.22 47.76 94.42 47.76 94.42 0.6 0.22 0.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-363",
    transform: "translate(353.000000, 2258.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-242",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-241"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-362"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-361",
    fill: "#949DA5",
    mask: "url(#mask-242)",
    points: "0.22 47.96 94.42 47.96 94.42 0.68 0.22 0.68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-366",
    transform: "translate(353.000000, 2352.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-244",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-243"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-365"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-364",
    fill: "#949DA5",
    mask: "url(#mask-244)",
    points: "0.22 48.04 94.42 48.04 94.42 0.88 0.22 0.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-369",
    transform: "translate(353.000000, 2447.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-246",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-245"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-367",
    fill: "#949DA5",
    mask: "url(#mask-246)",
    points: "0.22 47.12 94.42 47.12 94.42 -0.04 0.22 -0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-372",
    transform: "translate(353.000000, 2541.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-248",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-247"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-371"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-370",
    fill: "#949DA5",
    mask: "url(#mask-248)",
    points: "0.22 47.2 94.42 47.2 94.42 0.04 0.22 0.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-375",
    transform: "translate(353.000000, 2635.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-250",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-249"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-373",
    fill: "#949DA5",
    mask: "url(#mask-250)",
    points: "0.22 47.28 94.42 47.28 94.42 0.12 0.22 0.12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-378",
    transform: "translate(353.000000, 2729.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-252",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-251"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-377"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-376",
    fill: "#949DA5",
    mask: "url(#mask-252)",
    points: "0.22 47.48 94.42 47.48 94.42 0.2 0.22 0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-381",
    transform: "translate(353.000000, 2823.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-253"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-380"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-379",
    fill: "#949DA5",
    mask: "url(#mask-254)",
    points: "0.22 47.56 94.42 47.56 94.42 0.4 0.22 0.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-384",
    transform: "translate(353.000000, 2917.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-256",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-383"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-382",
    fill: "#949DA5",
    mask: "url(#mask-256)",
    points: "0.22 47.64 94.42 47.64 94.42 0.48 0.22 0.48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-387",
    transform: "translate(353.000000, 3011.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-258",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-257"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-386"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-385",
    fill: "#949DA5",
    mask: "url(#mask-258)",
    points: "0.22 47.72 94.42 47.72 94.42 0.56 0.22 0.56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-390",
    transform: "translate(353.000000, 3105.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-260",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-259"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-389"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-388",
    fill: "#949DA5",
    mask: "url(#mask-260)",
    points: "0.22 47.8 94.42 47.8 94.42 0.64 0.22 0.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-393",
    transform: "translate(353.000000, 3199.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-262",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-261"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-392"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-391",
    fill: "#949DA5",
    mask: "url(#mask-262)",
    points: "0.22 48 94.42 48 94.42 0.84 0.22 0.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-396",
    transform: "translate(353.000000, 3293.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-264",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-263"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-395"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-394",
    fill: "#949DA5",
    mask: "url(#mask-264)",
    points: "0.22 48.08 94.42 48.08 94.42 0.92 0.22 0.92"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/heroImage.6b62041163dc2045280286c4b8dc3820.svg";
export { ForwardRef as ReactComponent };